function initCsChatbot() {
  if (window.__csChatbotInitialized) return;
  window.__csChatbotInitialized = true;

  // =========================
  // CHAT OPEN/CLOSE
  // =========================

  const toggle =
    document.getElementById("cs-chat-toggle");

  const container =
    document.getElementById("chatbot-container");

  const closeBtn =
    document.getElementById("chat-close");

  if (!toggle || !container || !closeBtn) return;

  const DRAG_THRESHOLD = 6;
  let launcherDragMoved = false;
  let launcherDragging = false;
  let launcherDragStartX = 0;
  let launcherDragStartY = 0;
  let launcherStartLeft = 0;
  let launcherStartTop = 0;

  function clampLauncher(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function resetLauncherPosition() {
    // Clear any drag overrides so CSS bottom/right pinning wins again
    toggle.style.top = "";
    toggle.style.left = "";
    toggle.style.bottom = "";
    toggle.style.right = "";
    toggle.style.removeProperty("top");
    toggle.style.removeProperty("left");
    toggle.style.removeProperty("bottom");
    toggle.style.removeProperty("right");
  }

  function applyLauncherPosition(left, top) {
    const margin = 12;
    const rect = toggle.getBoundingClientRect();
    const width = rect.width || 60;
    const height = rect.height || 60;

    left = clampLauncher(left, margin, window.innerWidth - width - margin);
    top = clampLauncher(top, margin, window.innerHeight - height - margin);

    // Use !important so this wins over the pinned bottom-right CSS while dragging
    toggle.style.setProperty("bottom", "auto", "important");
    toggle.style.setProperty("right", "auto", "important");
    toggle.style.setProperty("left", left + "px", "important");
    toggle.style.setProperty("top", top + "px", "important");

    return { left, top };
  }

  function initLauncherPosition() {
    localStorage.removeItem("cs_chat_launcher_pos");
    resetLauncherPosition();
  }

  function positionChatContainerNearLauncher() {
    if (window.innerWidth <= 480) {
      container.style.top = "auto";
      container.style.left = "10px";
      container.style.right = "10px";
      container.style.bottom = "10px";
      return;
    }

    // Desktop: always pin bottom-right within the viewport (no top overflow).
    container.style.top = "auto";
    container.style.left = "auto";
    container.style.right = "24px";
    container.style.bottom = "24px";
    container.style.height = "";
    container.style.maxHeight = "";
  }

  function onLauncherPointerDown(e) {
    if (e.pointerType === "mouse" && e.button !== 0) return;

    launcherDragging = true;
    launcherDragMoved = false;
    launcherDragStartX = e.clientX;
    launcherDragStartY = e.clientY;

    const rect = toggle.getBoundingClientRect();
    launcherStartLeft = rect.left;
    launcherStartTop = rect.top;

    toggle.classList.add("cs-launcher-dragging");
    toggle.setPointerCapture(e.pointerId);
  }

  function onLauncherPointerMove(e) {
    if (!launcherDragging) return;

    const dx = e.clientX - launcherDragStartX;
    const dy = e.clientY - launcherDragStartY;

    if (Math.abs(dx) <= DRAG_THRESHOLD && Math.abs(dy) <= DRAG_THRESHOLD) {
      return;
    }

    launcherDragMoved = true;
    applyLauncherPosition(launcherStartLeft + dx, launcherStartTop + dy);
  }

  function onLauncherPointerUp(e) {
    if (!launcherDragging) return;

    launcherDragging = false;
    toggle.classList.remove("cs-launcher-dragging");

    if (toggle.hasPointerCapture(e.pointerId)) {
      toggle.releasePointerCapture(e.pointerId);
    }

    // Always re-pin to bottom-right after drag/click so the launcher can't
    // end up with bottom/right cleared while top/left stay CSS-locked to auto.
    resetLauncherPosition();
  }

  toggle.addEventListener("pointerdown", onLauncherPointerDown);
  toggle.addEventListener("pointermove", onLauncherPointerMove);
  toggle.addEventListener("pointerup", onLauncherPointerUp);
  toggle.addEventListener("pointercancel", onLauncherPointerUp);

  window.addEventListener("resize", () => {
    if (toggle.style.display === "none") return;
    resetLauncherPosition();
  });

  initLauncherPosition();

  // =========================
  // CHAT SETTINGS
  // =========================

  const settingsBtn = document.getElementById("chat-settings");
  const settingsOverlay = document.getElementById("chat-more-sheet");
  const settingsList = document.getElementById("chat-settings-list");
  const settingsBackdrop = settingsOverlay?.querySelector("[data-more-dismiss]");

  const CHAT_SETTINGS_KEY = "cs_chat_settings";
  const CHAT_SETTINGS_DEFAULTS = { largeFont: false };

  let chatSettings = loadSettings();

  const CHAT_SETTINGS_DEFS = [
    {
      id: "downloadTranscript",
      label: "Download chat history",
      type: "action",
    },
    {
      id: "giveFeedback",
      label: "Give feedback",
      type: "action",
    },
    {
      id: "largeFont",
      label: "Make font bigger",
      type: "toggle",
      apply(cont, enabled) {
        cont.classList.toggle("cs-chat-font-large", enabled);
      },
    },
  ];

  let transcriptDownloadInProgress = false;

  function loadSettings() {
    try {
      const stored = JSON.parse(localStorage.getItem(CHAT_SETTINGS_KEY) || "{}");
      return { ...CHAT_SETTINGS_DEFAULTS, ...stored };
    } catch {
      return { ...CHAT_SETTINGS_DEFAULTS };
    }
  }

  function saveSettings() {
    localStorage.setItem(CHAT_SETTINGS_KEY, JSON.stringify(chatSettings));
  }

  function applyAllSettings() {
    CHAT_SETTINGS_DEFS.forEach((def) => {
      if (typeof def.apply === "function") {
        def.apply(container, !!chatSettings[def.id]);
      }
    });
  }

  function renderSettingsPanel() {
    if (!settingsList) return;
    settingsList.innerHTML = CHAT_SETTINGS_DEFS.map((def) => {
      if (def.type === "toggle") {
        const checked = chatSettings[def.id] ? " checked" : "";
        return (
          '<div class="chat-more-row chat-more-row--toggle">' +
            '<span class="chat-more-row-label">' + def.label + "</span>" +
            '<label class="chat-more-toggle">' +
              '<input type="checkbox" data-setting-id="' + def.id + '"' + checked + ">" +
              '<span class="chat-more-toggle-slider"></span>' +
            "</label>" +
          "</div>"
        );
      }
      if (def.type === "action") {
        return (
          '<button type="button" class="chat-more-row chat-more-row--action" data-setting-action="' + def.id + '">' +
            '<span class="chat-more-row-label">' + def.label + "</span>" +
            '<span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>' +
          "</button>"
        );
      }
      return "";
    }).join("");

    settingsList.querySelectorAll("[data-setting-id]").forEach((input) => {
      input.addEventListener("change", () => {
        const id = input.dataset.settingId;
        chatSettings[id] = input.checked;
        saveSettings();
        applyAllSettings();
      });
    });

    settingsList.querySelectorAll("[data-setting-action]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.dataset.settingAction === "giveFeedback") {
          openCustomerFeedback();
        } else if (btn.dataset.settingAction === "downloadTranscript") {
          downloadChatTranscript();
        }
      });
      if (
        btn.dataset.settingAction === "downloadTranscript" &&
        transcriptDownloadInProgress
      ) {
        btn.disabled = true;
        btn.classList.add("chat-more-row--loading");
        const label = btn.querySelector(".chat-more-row-label");
        if (label) label.textContent = "Preparing PDF…";
      }
    });
  }

  function isSettingsOpen() {
    return settingsOverlay && !settingsOverlay.hidden;
  }

  function openSettingsOverlay() {
    if (!settingsOverlay || !settingsBtn) return;
    settingsOverlay.hidden = false;
    settingsOverlay.setAttribute("aria-hidden", "false");
    settingsOverlay.classList.add("chat-more-sheet--open");
    settingsBtn.setAttribute("aria-expanded", "true");
  }

  function closeSettingsOverlay() {
    if (!settingsOverlay || !settingsBtn) return;
    settingsOverlay.hidden = true;
    settingsOverlay.setAttribute("aria-hidden", "true");
    settingsOverlay.classList.remove("chat-more-sheet--open");
    settingsBtn.setAttribute("aria-expanded", "false");
  }

  renderSettingsPanel();
  applyAllSettings();

  settingsBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    if (isSettingsOpen()) {
      closeSettingsOverlay();
    } else {
      openSettingsOverlay();
    }
  });

  settingsBackdrop?.addEventListener("click", () => {
    closeSettingsOverlay();
  });

  document.addEventListener("mousedown", (e) => {
    if (!isSettingsOpen()) return;
    if (settingsOverlay.contains(e.target) || settingsBtn.contains(e.target)) return;
    closeSettingsOverlay();
  });

  // Shows the initial "How can we help?" AI greeting once per empty,
  // conversation-less open. Cleared whenever real history loads.
  let greetingSeeded = false;

  function seedGreetingIfNeeded() {
    if (greetingSeeded) return;
    if (!messages || messages.children.length > 0) return;
    greetingSeeded = true;
    appendMessage("agent-message", "How can we help?", "AI", new Date());
  }

  // Ignore outside-clicks briefly after open so the same user gesture that
  // lazy-loaded the widget cannot immediately close it again.
  let ignoreOutsideClickUntil = 0;

  function openChat() {
    unlockChime();
    positionChatContainerNearLauncher();

    ignoreOutsideClickUntil = Date.now() + 500;
    container.style.display = "flex";
    toggle.style.display = "none";
    isChatOpen = true;

    updateUnreadBadge(0);

    const conversationId =
      localStorage.getItem("chat_conversation_id");

    const storedName = localStorage.getItem(CUSTOMER_NAME_KEY);
    if (storedName) customerName = storedName;

    if (conversationId) {
      announceActive();
      socket.emit("customer-chat-open", { conversationId });
      scheduleCartSync();
      loadChatHistory();
    } else {
      seedGreetingIfNeeded();
    }

    if (document.visibilityState === "visible") {
      markConversationSeen();
    }

    applyAllSettings();
  }

  function closeChat() {
    closeSettingsOverlay();
    closeNameModal();
    closeContextualFeedbackModal();
    container.style.display = "none";
    toggle.style.display = "flex";
    resetLauncherPosition();
    isChatOpen = false;

    const conversationId =
      localStorage.getItem("chat_conversation_id");
    if (conversationId) {
      socket.emit("customer-chat-closed", { conversationId });
    }
  }

  // Used by the lazy-load snippet after first launcher press
  window.__csOpenChatbot = openChat;

  toggle.addEventListener("click", () => {
    if (launcherDragMoved) {
      launcherDragMoved = false;
      return;
    }
    openChat();
  });

  closeBtn.addEventListener("click", () => {
    closeChat();
  });

  // Close chatbot when clicking outside
  document.addEventListener("click", (e) => {
    if (Date.now() < ignoreOutsideClickUntil) return;

    if (isNameModalOpen() && nameModal.contains(e.target)) return;
    if (isSettingsOpen() && settingsOverlay.contains(e.target)) return;
    // Keep chat open while contextual reasons / "Tell us more" modal is showing
    if (contextualFeedbackCard && contextualFeedbackCard.classList.contains("is-open")) return;

    if (container.style.display === "flex") {
      if (!container.contains(e.target) && !toggle.contains(e.target)) {
        closeChat();
      }
    }

  });

  // =========================
  // SCREENS
  // =========================

  const chatScreen =
    document.getElementById("chat-screen");

  // =========================
  // NAME MODAL
  // =========================

  const CUSTOMER_NAME_KEY = "chat_customer_name";
  let customerName = localStorage.getItem(CUSTOMER_NAME_KEY) || "";

  const nameModal =
    document.getElementById("name-modal");

  const customerNameInput =
    document.getElementById("customer-name");

  const nameSubmitBtn =
    document.getElementById("name-submit-btn");

  // Stashed message intent captured before the name modal was opened
  let pendingSend = null;

  function isNameModalOpen() {
    return nameModal && !nameModal.hidden;
  }

  function openNameModal() {
    if (!nameModal) return;
    nameModal.hidden = false;
    nameModal.setAttribute("aria-hidden", "false");
    nameModal.classList.add("name-modal--open");
    if (customerNameInput) {
      customerNameInput.value = "";
      customerNameInput.focus();
    }
  }

  function closeNameModal() {
    if (!nameModal) return;
    nameModal.hidden = true;
    nameModal.setAttribute("aria-hidden", "true");
    nameModal.classList.remove("name-modal--open");
  }

  function submitNameModal() {
    const name = customerNameInput ? customerNameInput.value.trim() : "";
    if (!name) {
      customerNameInput?.focus();
      return;
    }
    customerName = name;
    localStorage.setItem(CUSTOMER_NAME_KEY, customerName);
    closeNameModal();

    const pending = pendingSend;
    pendingSend = null;
    if (pending && pending.type === "giphy") {
      sendGiphyAttachment(pending.gif);
    } else if (pending) {
      sendMessage();
    }
    input.focus();
  }

  nameSubmitBtn?.addEventListener("click", submitNameModal);

  customerNameInput?.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submitNameModal();
    }
  });

  // =========================
  // SOCKET
  // =========================

  // https://supporthero.behope.com
  const BACKEND_URL = "https://supporthero.behope.com";


  function isTrackingParam(key) {
    var k = String(key || "").toLowerCase();
    if (!k) return false;
    if (k.indexOf("utm_") === 0) return true;
    if (k.indexOf("gad_") === 0) return true;
    var exact = {
      gclid: 1, gbraid: 1, wbraid: 1, gad_source: 1, gad_campaignid: 1,
      fbclid: 1, msclkid: 1, mc_cid: 1, mc_eid: 1, _ga: 1, _gl: 1,
      dclid: 1, twclid: 1, li_fat_id: 1, igshid: 1, ttclid: 1,
      yclid: 1, vero_id: 1, mkt_tok: 1
    };
    return !!exact[k];
  }

  function cleanPageUrl(raw) {
    if (raw == null) return raw;
    var input = String(raw).trim();
    if (!input) return input;
    try {
      var url = new URL(input);
      var keys = Array.prototype.slice.call(url.searchParams.keys());
      keys.forEach(function (key) {
        if (isTrackingParam(key)) url.searchParams.delete(key);
      });
      if (!Array.prototype.slice.call(url.searchParams.keys()).length) {
        url.search = "";
      }
      if (
        url.hash === "#" ||
        url.hash === "" ||
        String(url.hash).toLowerCase() === "#open-chat"
      ) {
        url.hash = "";
      }
      return url.toString();
    } catch (e) {
      return input;
    }
  }

  const socket = io(
    BACKEND_URL,
    {
      transports: ["websocket", "polling"]
    }
  );

  // ── Delivery status (customer messages → agent) ──
  var messageStatuses = {};
  var STATUS_ORDER = { sent: 0, delivered: 1, seen: 2 };

  function statusFromDbFields(msg) {
    if (msg.seen) return "seen";
    if (msg.delivered) return "delivered";
    return "sent";
  }

  function createDeliveryTicks(status) {
    var label = status.charAt(0).toUpperCase() + status.slice(1);
    var el = document.createElement("span");
    el.className = "msg-ticks msg-ticks-" + status;
    el.title = label;
    el.setAttribute("aria-label", label);
    var icon = document.createElement("span");
    icon.className = "material-symbols-outlined";
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = status === "sent" ? "done" : "done_all";
    el.appendChild(icon);
    return el;
  }

  function applyMessageStatus(messageId, status) {
    if (!messageId || !status) return;
    var current = messageStatuses[messageId];
    if (current && STATUS_ORDER[current] >= STATUS_ORDER[status]) return;

    // Ensure delivered (gray double tick) is shown before seen (blue double tick)
    if (status === "seen" && (!current || current === "sent")) {
      messageStatuses[messageId] = "delivered";
      updateMessageTicks(messageId, "delivered");
      requestAnimationFrame(function() {
        messageStatuses[messageId] = "seen";
        updateMessageTicks(messageId, "seen");
      });
      return;
    }

    messageStatuses[messageId] = status;
    updateMessageTicks(messageId, status);
  }

  function updateMessageTicks(messageId, status) {
    var container = messages.querySelector('[data-message-id="' + messageId + '"]');
    if (!container) return;
    var meta = container.querySelector(".msg-meta-me");
    if (!meta) return;
    var ticksEl = meta.querySelector(".msg-ticks");
    if (!ticksEl) {
      ticksEl = createDeliveryTicks(status);
      meta.appendChild(ticksEl);
      return;
    }
    var label = status.charAt(0).toUpperCase() + status.slice(1);
    ticksEl.className = "msg-ticks msg-ticks-" + status;
    ticksEl.title = label;
    ticksEl.setAttribute("aria-label", label);
    var icon = ticksEl.querySelector(".material-symbols-outlined");
    if (icon) icon.textContent = status === "sent" ? "done" : "done_all";
  }

  function finishUserContainer(container, timeString, messageId, deliveryStatus) {
    if (messageId) container.dataset.messageId = messageId;
    var meta = document.createElement("div");
    meta.className = "msg-meta msg-meta-me";
    var timeSpan = document.createElement("span");
    timeSpan.className = "msg-meta-time";
    timeSpan.textContent = timeString;
    meta.appendChild(timeSpan);
    if (messageId) {
      var status = deliveryStatus || "sent";
      messageStatuses[messageId] = status;
      meta.appendChild(createDeliveryTicks(status));
    }
    container.appendChild(meta);
  }

  socket.on("message-status", function(data) {
    if (data && data.messageId && data.status) {
      applyMessageStatus(data.messageId, data.status);
    }
  });

  const sendBtn =
    document.getElementById("chat-send");

  const input =
    document.getElementById("chat-input");

  const messages =
    document.getElementById("chat-messages");

  const scrollBottomBtn =
    document.getElementById("chat-scroll-bottom");

  function isChatNearBottom() {
    return messages.scrollHeight - messages.scrollTop - messages.clientHeight < 80;
  }

  function updateScrollBottomBtn() {
    if (!scrollBottomBtn) return;
    scrollBottomBtn.hidden = isChatNearBottom() || chatScreen.style.display === "none";
  }

  function scrollMessagesToBottom() {
    messages.scrollTop = messages.scrollHeight;
    updateScrollBottomBtn();
  }

  function bindImageScroll(container) {
    if (!container) return;
    container.querySelectorAll("img.message-image").forEach(function (img) {
      if (img.complete) return;
      img.addEventListener("load", scrollMessagesToBottom, { once: true });
      img.addEventListener("error", scrollMessagesToBottom, { once: true });
    });
  }

  scrollBottomBtn?.addEventListener("click", () => {
    messages.scrollTo({ top: messages.scrollHeight, behavior: "smooth" });
  });

  const attachBtn =
    document.getElementById("chat-attach");

  let aiResponding = false;
  let sendInProgress = false;

  function setInputDisabled(disabled) {
    input.disabled = !!disabled;
    sendBtn.disabled = !!disabled;
    if (attachBtn) attachBtn.disabled = !!disabled;
  }

  function applyAiRespondingLock(responding) {
    aiResponding = !!responding;
    setInputDisabled(responding);
  }

  const fileInput =
    document.getElementById("chat-file-input");

  const filePreview =
    document.getElementById("chat-file-preview");

  // Currently selected files (cleared after send) — max 5
  let pendingFiles = [];

  // =========================
  // FILE ATTACH
  // =========================

  const MAX_FILES = 5;
  const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];

  attachBtn.addEventListener("click", () => fileInput.click());

  function addPendingFiles(selected) {
    if (!selected.length) return;

    const valid = [];
    for (const file of selected) {
      if (!ALLOWED_TYPES.includes(file.type)) {
        showFileToast("Only JPG, PNG and WEBP images are allowed.");
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showFileToast(`"${file.name}" exceeds the 5 MB limit.`);
        return;
      }
      valid.push(file);
    }

    const merged = [...pendingFiles, ...valid];
    if (merged.length > MAX_FILES) {
      showFileToast(`Only ${MAX_FILES} images allowed. Extra files removed.`);
    }
    pendingFiles = merged.slice(0, MAX_FILES);
    renderFilePreviews();
  }

  fileInput.addEventListener("change", () => {
    const selected = Array.from(fileInput.files);
    fileInput.value = "";
    addPendingFiles(selected);
  });

  function showFileToast(msg) {
    const existing = document.getElementById("chat-file-toast");
    if (existing) existing.remove();
    const toast = document.createElement("div");
    toast.id = "chat-file-toast";
    toast.className = "chat-file-toast";
    toast.textContent = "⚠ " + msg;
    filePreview.parentNode.insertBefore(toast, filePreview);
    setTimeout(() => toast.remove(), 3500);
  }

  function renderFilePreviews() {
    filePreview.innerHTML = "";

    if (!pendingFiles.length) {
      filePreview.style.display = "none";
      return;
    }

    filePreview.style.display = "flex";

    pendingFiles.forEach((file) => {
      const chip = document.createElement("div");
      chip.className = "chat-file-chip";

      const thumb = document.createElement("img");
      thumb.src = URL.createObjectURL(file);
      thumb.className = "chat-file-preview-thumb";
      thumb.alt = "";

      const name = document.createElement("span");
      name.className = "chat-file-chip-name";
      name.textContent = file.name;
      name.title = file.name;

      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "chat-file-chip-remove";
      removeBtn.setAttribute("aria-label", "Remove attachment");
      removeBtn.innerHTML = '<span class="material-symbols-outlined" aria-hidden="true">close</span>';
      removeBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        const idx = pendingFiles.indexOf(file);
        if (idx === -1) return;
        URL.revokeObjectURL(thumb.src);
        pendingFiles.splice(idx, 1);
        renderFilePreviews();
      });

      chip.appendChild(thumb);
      chip.appendChild(name);
      chip.appendChild(removeBtn);
      filePreview.appendChild(chip);
    });
  }

  function installDragDrop() {
    const chatScreen = document.getElementById("chat-screen");
    const dropOverlay = document.getElementById("chat-drop-overlay");
    if (!chatScreen || !dropOverlay) return;

    let dragDepth = 0;

    function isFileDrag(e) {
      return Array.from(e.dataTransfer?.types || []).includes("Files");
    }

    function showDropOverlay() {
      dropOverlay.classList.add("chat-drop-overlay--visible");
      dropOverlay.setAttribute("aria-hidden", "false");
    }

    function hideDropOverlay() {
      dragDepth = 0;
      dropOverlay.classList.remove("chat-drop-overlay--visible");
      dropOverlay.setAttribute("aria-hidden", "true");
    }

    chatScreen.addEventListener("dragenter", (e) => {
      if (!isFileDrag(e) || chatScreen.style.display === "none") return;
      e.preventDefault();
      dragDepth++;
      showDropOverlay();
    });

    chatScreen.addEventListener("dragover", (e) => {
      if (!isFileDrag(e) || chatScreen.style.display === "none") return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    });

    chatScreen.addEventListener("dragleave", (e) => {
      if (!isFileDrag(e)) return;
      e.preventDefault();
      dragDepth--;
      if (dragDepth <= 0) hideDropOverlay();
    });

    chatScreen.addEventListener("drop", (e) => {
      if (!isFileDrag(e) || chatScreen.style.display === "none") return;
      e.preventDefault();
      hideDropOverlay();
      addPendingFiles(Array.from(e.dataTransfer.files));
    });
  }

  installDragDrop();

  function clearPendingFiles() {
    // Revoke any object URLs to free memory
    const imgs = filePreview.querySelectorAll("img");
    imgs.forEach((img) => URL.revokeObjectURL(img.src));
    pendingFiles = [];
    fileInput.value = "";
    filePreview.style.display = "none";
    filePreview.innerHTML = "";
  }

  function isImageAttachment(attOrFileId, fileMime, fileName) {
    // Support both attachment object and legacy (fileId, mime, name) args
    if (attOrFileId && typeof attOrFileId === "object") {
      var att = attOrFileId;
      if (att.url || att.source === "giphy") return true;
      if (att.fileId && att.fileMime && att.fileMime.startsWith("image/")) return true;
      if (att.fileId && att.fileName && /\.(jpe?g|png|webp|gif)$/i.test(att.fileName)) return true;
      return false;
    }
    var fileId = attOrFileId;
    if (fileId && fileMime && fileMime.startsWith("image/")) return true;
    if (fileId && fileName && /\.(jpe?g|png|webp|gif)$/i.test(fileName)) return true;
    if (!fileId && fileMime && fileMime.startsWith("image/")) return false;
    return false;
  }

  function attachmentImageSrc(att) {
    if (att && att.fileId) return BACKEND_URL + "/files/" + encodeURIComponent(att.fileId);
    if (att && att.url) return att.url;
    return "";
  }

  async function uploadFile(file, conversationId) {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(
      `${BACKEND_URL}/upload?role=customer&conversationId=${encodeURIComponent(conversationId)}`,
      { method: "POST", body: formData }
    );
    const data = await res.json();
    if (!data.success) throw new Error(data.message || "Upload failed");
    return data;
  }

  async function uploadFiles(files, conversationId) {
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    const res = await fetch(
      `${BACKEND_URL}/upload?role=customer&conversationId=${encodeURIComponent(conversationId)}`,
      { method: "POST", body: formData }
    );
    const data = await res.json();
    if (!data.success) throw new Error(data.message || "Upload failed");
    // Normalize: single file returns flat, multi returns { attachments: [...] }
    if (data.attachments) return data.attachments;
    return [{ fileId: data.fileId, fileS3Key: data.fileS3Key, fileName: data.fileName, fileMime: data.fileMime, fileSize: data.fileSize, url: data.url }];
  }

  // Track chatbot open state for status reporting
  let isChatOpen = false;

  // ── Message chime (plays when agent replies while chat is closed) ──
  const chimeUrl = window.chatbotConfig?.chimeUrl || null;
  let chimeAudio = null;
  let chimeUnlocked = false;

  function unlockChime() {
    requestNotificationPermission();
    if (chimeUnlocked || !chimeUrl) return;
    chimeAudio = new Audio(chimeUrl);
    chimeAudio.volume = 1.0;
    chimeAudio.play()
      .then(() => {
        chimeAudio.pause();
        chimeAudio.currentTime = 0;
        chimeUnlocked = true;
      })
      .catch(() => {});
  }

  function playChime() {
    if (!chimeUrl) return;
    if (!chimeAudio) chimeAudio = new Audio(chimeUrl);
    chimeAudio.volume = 1.0;
    chimeAudio.currentTime = 0;
    chimeAudio.play().catch(() => {});
  }

  // ── Browser notifications (when agent replies while customer is not actively viewing) ──
  const NOTIF_ASKED_KEY = "cs_notifications_asked";

  function notificationsSupported() {
    return typeof Notification !== "undefined";
  }

  function getNotificationIcon() {
    const iconLink = document.querySelector(
      'link[rel="apple-touch-icon"], link[rel="icon"]'
    );
    return iconLink?.href || null;
  }

  function requestNotificationPermission() {
    if (!notificationsSupported()) return;
    if (Notification.permission !== "default") return;
    if (localStorage.getItem(NOTIF_ASKED_KEY)) return;

    Notification.requestPermission()
      .then(() => {
        localStorage.setItem(NOTIF_ASKED_KEY, "1");
      })
      .catch(() => {
        localStorage.setItem(NOTIF_ASKED_KEY, "1");
      });
  }

  function shouldAlertCustomer(sender, fromZendesk) {
    if (!fromZendesk || sender === "System" || sender === "__feedback__") return false;
    if (isChatOpen && document.visibilityState === "visible") return false;
    return true;
  }

  function shouldShowBrowserNotification(sender, fromZendesk) {
    return (
      shouldAlertCustomer(sender, fromZendesk) &&
      notificationsSupported() &&
      Notification.permission === "granted"
    );
  }

  function showBrowserNotification({ sender, message, fileName, fileId }) {
    let body = (message || "").trim();
    if (!body && (fileId || fileName)) {
      body = fileName ? `Sent ${fileName}` : "Sent an attachment";
    }
    if (!body) body = "New message from support";

    const notification = new Notification(sender || "BeHope Support", {
      body,
      tag: getConversationId() || "cs-chat",
      icon: getNotificationIcon() || undefined,
    });

    notification.onclick = () => {
      window.focus();
      notification.close();
      openChat();
    };
  }

  // ── Unread badge on the toggle button ──
  var unreadBadge = null;

  function getOrCreateBadge() {
    if (!unreadBadge) {
      unreadBadge = document.createElement('span');
      unreadBadge.id = 'cs-unread-badge';
      unreadBadge.className = 'cs-unread-badge';
      toggle.appendChild(unreadBadge);
    }
    return unreadBadge;
  }

  function updateUnreadBadge(count) {
    if (count > 0) {
      var badge = getOrCreateBadge();
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.style.display = 'flex';
    } else if (unreadBadge) {
      unreadBadge.style.display = 'none';
    }
  }

  function getConversationId() {
    return localStorage.getItem("chat_conversation_id");
  }

  // =========================
  // EMOJI PICKER
  // =========================

  const EMOJI_DATA = [
    // Smileys
    { e: "😀", n: "grinning", c: "smileys" }, { e: "😃", n: "smiley", c: "smileys" },
    { e: "😄", n: "smile", c: "smileys" }, { e: "😁", n: "grin", c: "smileys" },
    { e: "😆", n: "laughing", c: "smileys" }, { e: "😅", n: "sweat smile", c: "smileys" },
    { e: "🤣", n: "rofl", c: "smileys" }, { e: "😂", n: "joy", c: "smileys" },
    { e: "🙂", n: "slightly smiling", c: "smileys" }, { e: "😊", n: "blush", c: "smileys" },
    { e: "😇", n: "innocent", c: "smileys" }, { e: "😉", n: "wink", c: "smileys" },
    { e: "😌", n: "relieved", c: "smileys" }, { e: "😍", n: "heart eyes", c: "smileys" },
    { e: "🥰", n: "smiling hearts", c: "smileys" }, { e: "😘", n: "kissing heart", c: "smileys" },
    { e: "😋", n: "yum", c: "smileys" }, { e: "😜", n: "stuck out tongue wink", c: "smileys" },
    { e: "🤪", n: "zany", c: "smileys" }, { e: "😝", n: "stuck out tongue closed eyes", c: "smileys" },
    { e: "🤑", n: "money mouth", c: "smileys" }, { e: "🤗", n: "hugging", c: "smileys" },
    { e: "🤔", n: "thinking", c: "smileys" }, { e: "🤐", n: "zipper mouth", c: "smileys" },
    { e: "😐", n: "neutral", c: "smileys" }, { e: "😑", n: "expressionless", c: "smileys" },
    { e: "😶", n: "no mouth", c: "smileys" }, { e: "😏", n: "smirk", c: "smileys" },
    { e: "😒", n: "unamused", c: "smileys" }, { e: "🙄", n: "rolling eyes", c: "smileys" },
    { e: "😬", n: "grimacing", c: "smileys" }, { e: "🤥", n: "lying", c: "smileys" },
    { e: "😔", n: "pensive", c: "smileys" }, { e: "😪", n: "sleepy", c: "smileys" },
    { e: "🤤", n: "drooling", c: "smileys" }, { e: "😴", n: "sleeping", c: "smileys" },
    { e: "😷", n: "mask", c: "smileys" }, { e: "🤒", n: "sick", c: "smileys" },
    { e: "🤕", n: "injured", c: "smileys" }, { e: "🤢", n: "nauseated", c: "smileys" },
    { e: "🤮", n: "vomiting", c: "smileys" }, { e: "🥵", n: "hot", c: "smileys" },
    { e: "🥶", n: "cold", c: "smileys" }, { e: "😵", n: "dizzy", c: "smileys" },
    { e: "🤯", n: "exploding head", c: "smileys" }, { e: "🥳", n: "party", c: "smileys" },
    { e: "🥺", n: "pleading", c: "smileys" }, { e: "😢", n: "cry", c: "smileys" },
    { e: "😭", n: "sob", c: "smileys" }, { e: "😤", n: "triumph", c: "smileys" },
    { e: "😠", n: "angry", c: "smileys" }, { e: "😡", n: "rage", c: "smileys" },
    // People
    { e: "👋", n: "wave", c: "people" }, { e: "🤚", n: "raised back of hand", c: "people" },
    { e: "✋", n: "raised hand", c: "people" }, { e: "🖖", n: "vulcan salute", c: "people" },
    { e: "👌", n: "ok hand", c: "people" }, { e: "🤌", n: "pinched fingers", c: "people" },
    { e: "🤏", n: "pinching hand", c: "people" }, { e: "✌️", n: "peace", c: "people" },
    { e: "🤞", n: "crossed fingers", c: "people" }, { e: "🤟", n: "love you", c: "people" },
    { e: "🤘", n: "rock on", c: "people" }, { e: "🤙", n: "call me", c: "people" },
    { e: "👈", n: "point left", c: "people" }, { e: "👉", n: "point right", c: "people" },
    { e: "👆", n: "point up", c: "people" }, { e: "👇", n: "point down", c: "people" },
    { e: "👍", n: "thumbs up", c: "people" }, { e: "👎", n: "thumbs down", c: "people" },
    { e: "👏", n: "clap", c: "people" }, { e: "🙌", n: "raised hands", c: "people" },
    { e: "🤝", n: "handshake", c: "people" }, { e: "🙏", n: "pray", c: "people" },
    { e: "💪", n: "strong", c: "people" }, { e: "🦾", n: "mechanical arm", c: "people" },
  ];

  const EMOJI_CATEGORIES = [
    { id: "smileys", label: "😀" },
    { id: "people", label: "👋" },
  ];

  const emojiPanel = document.getElementById("chat-emoji-panel");
  const emojiBtn = document.getElementById("chat-emoji-btn");
  const emojiSearch = document.getElementById("emoji-search");
  const emojiTabs = document.getElementById("emoji-tabs");
  const emojiGrid = document.getElementById("emoji-grid");
  const giphyPanel = document.getElementById("chat-giphy-panel");
  const gifBtn = document.getElementById("chat-gif-btn");
  const giphySearch = document.getElementById("giphy-search");
  const giphyGrid = document.getElementById("giphy-grid");
  let activeEmojiCategory = "smileys";
  let giphyDebounce = null;
  let giphyRequestId = 0;

  function renderEmojiTabs() {
    emojiTabs.innerHTML = EMOJI_CATEGORIES.map(function (cat) {
      var active = cat.id === activeEmojiCategory ? " active" : "";
      return '<button type="button" class="emoji-tab' + active + '" data-cat="' + cat.id + '" title="' + cat.id + '">' + cat.label + '</button>';
    }).join("");
  }

  function renderEmojiGrid(filter) {
    var query = (filter || "").toLowerCase().trim();
    var emojis = query
      ? EMOJI_DATA.filter(function (d) { return d.n.indexOf(query) !== -1; })
      : EMOJI_DATA.filter(function (d) { return d.c === activeEmojiCategory; });

    if (emojis.length === 0) {
      emojiGrid.innerHTML = '<div class="emoji-empty">No emojis found</div>';
      return;
    }

    emojiGrid.innerHTML = emojis.map(function (d) {
      return '<button type="button" class="emoji-cell" title="' + d.n + '">' + d.e + '</button>';
    }).join("");
  }

  // Toggle picker
  emojiBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    var isOpen = emojiPanel.style.display !== "none";
    if (giphyPanel) giphyPanel.style.display = "none";
    if (isOpen) {
      emojiPanel.style.display = "none";
    } else {
      emojiSearch.value = "";
      activeEmojiCategory = "smileys";
      renderEmojiTabs();
      renderEmojiGrid();
      emojiPanel.style.display = "";
      emojiSearch.focus();
    }
  });

  // Category tab click
  emojiTabs.addEventListener("click", function (e) {
    e.stopPropagation();
    var tab = e.target.closest(".emoji-tab");
    if (!tab) return;
    activeEmojiCategory = tab.dataset.cat;
    emojiSearch.value = "";
    renderEmojiTabs();
    renderEmojiGrid();
  });

  // Search
  emojiSearch.addEventListener("input", function () {
    renderEmojiGrid(emojiSearch.value);
  });

  // Emoji select — insert at cursor position and close
  emojiGrid.addEventListener("click", function (e) {
    e.stopPropagation();
    var cell = e.target.closest(".emoji-cell");
    if (!cell) return;
    var emoji = cell.textContent;
    var start = input.selectionStart;
    var end = input.selectionEnd;
    var before = input.value.slice(0, start);
    var after = input.value.slice(end);
    input.value = before + emoji + after;

    // Set cursor after inserted emoji
    var newPos = start + emoji.length;
    input.selectionStart = newPos;
    input.selectionEnd = newPos;

    // Trigger typing event
    input.dispatchEvent(new Event("input", { bubbles: true }));

    // Close picker
    emojiPanel.style.display = "none";
    input.focus();
  });

  // Close on click outside
  document.addEventListener("mousedown", function (e) {
    if (emojiPanel.style.display === "none") return;
    if (emojiPanel.contains(e.target) || emojiBtn.contains(e.target)) return;
    emojiPanel.style.display = "none";
  });

  // Close on Escape
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (isSettingsOpen()) {
      closeSettingsOverlay();
      return;
    }
    if (isNameModalOpen()) {
      closeNameModal();
      return;
    }
    if (giphyPanel && giphyPanel.style.display !== "none") {
      giphyPanel.style.display = "none";
      input.focus();
      return;
    }
    if (emojiPanel.style.display !== "none") {
      emojiPanel.style.display = "none";
      input.focus();
    }
  });

  // =========================
  // GIPHY PICKER
  // =========================

  function closeGiphyPanel() {
    if (giphyPanel) giphyPanel.style.display = "none";
  }

  function closeEmojiPanel() {
    if (emojiPanel) emojiPanel.style.display = "none";
  }

  async function fetchGiphy(path, params) {
    var qs = new URLSearchParams(params || {});
    var res = await fetch(BACKEND_URL + "/giphy/" + path + "?" + qs.toString());
    if (res.status === 503) {
      var err = new Error("Giphy is not configured");
      err.code = "not_configured";
      throw err;
    }
    if (!res.ok) throw new Error("Failed to load GIFs");
    return res.json();
  }

  function renderGiphyGrid(gifs, statusText) {
    if (!giphyGrid) return;
    if (statusText) {
      giphyGrid.innerHTML = '<div class="giphy-empty">' + statusText + "</div>";
      return;
    }
    if (!gifs || gifs.length === 0) {
      giphyGrid.innerHTML = '<div class="giphy-empty">No GIFs found</div>';
      return;
    }
    giphyGrid.innerHTML = gifs.map(function (gif) {
      var src = gif.previewUrl || gif.sendUrl || "";
      var title = (gif.title || "GIF").replace(/"/g, "&quot;");
      return (
        '<button type="button" class="giphy-cell" data-id="' + gif.id + '" data-url="' +
        String(gif.sendUrl || "").replace(/"/g, "&quot;") +
        '" title="' + title + '">' +
        '<img src="' + src.replace(/"/g, "&quot;") + '" alt="' + title + '" loading="lazy" />' +
        "</button>"
      );
    }).join("");
  }

  async function loadGiphy(query) {
    if (!giphyGrid) return;
    var requestId = ++giphyRequestId;
    renderGiphyGrid([], "Loading…");
    try {
      var data = query && query.trim()
        ? await fetchGiphy("search", { q: query.trim(), limit: 24 })
        : await fetchGiphy("trending", { limit: 24 });
      if (requestId !== giphyRequestId) return;
      renderGiphyGrid(data.gifs || []);
    } catch (err) {
      if (requestId !== giphyRequestId) return;
      renderGiphyGrid(
        [],
        err.code === "not_configured"
          ? "Giphy is not configured on the server."
          : "Could not load GIFs."
      );
    }
  }

  function sendGiphyAttachment(gif) {
    if (!gif || !gif.sendUrl || aiResponding) return;

    // Only gate brand-new chats; existing conversationId means the customer already onboarded
    if (!customerName && !localStorage.getItem("chat_conversation_id")) {
      pendingSend = { type: "giphy", gif: gif };
      closeGiphyPanel();
      openNameModal();
      return;
    }

    unlockChime();

    var conversationId = localStorage.getItem("chat_conversation_id") || null;
    var isNewConversation = !conversationId;
    var attachment = {
      fileId: null,
      fileName: "giphy.gif",
      fileMime: "image/gif",
      fileSize: null,
      url: gif.sendUrl,
      source: "giphy",
      giphyId: gif.id || null,
    };

    sendInProgress = true;
    setInputDisabled(true);

    var msgEl = appendMessage(
      "user-message",
      "",
      null,
      new Date(),
      null, null, null,
      [attachment]
    );

    var payload = {
      message: "",
      customerName: isNewConversation ? customerName : null,
      fromZendesk: false,
      conversationId: conversationId,
      pageUrl: cleanPageUrl(window.location.href),
      attachments: [attachment],
    };

    emitWithRetry(payload, msgEl);
    closeGiphyPanel();
    scheduleCartSync();
    sendInProgress = false;
    if (!aiResponding) setInputDisabled(false);
  }

  if (gifBtn && giphyPanel && giphySearch && giphyGrid) {
    gifBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = giphyPanel.style.display !== "none";
      closeEmojiPanel();
      if (isOpen) {
        closeGiphyPanel();
      } else {
        giphySearch.value = "";
        giphyPanel.style.display = "flex";
        loadGiphy("");
        giphySearch.focus();
      }
    });

    giphySearch.addEventListener("input", function () {
      clearTimeout(giphyDebounce);
      var value = giphySearch.value;
      giphyDebounce = setTimeout(function () {
        loadGiphy(value);
      }, 300);
    });

    giphyGrid.addEventListener("click", function (e) {
      e.stopPropagation();
      var cell = e.target.closest(".giphy-cell");
      if (!cell) return;
      sendGiphyAttachment({
        id: cell.dataset.id,
        sendUrl: cell.dataset.url,
        title: cell.title,
      });
    });

    document.addEventListener("mousedown", function (e) {
      if (giphyPanel.style.display === "none") return;
      if (giphyPanel.contains(e.target) || gifBtn.contains(e.target)) return;
      closeGiphyPanel();
    });
  }

  // =========================
  // CART SYNC + CHAT ATTRIBUTION
  // =========================

  let cartSyncTimer = null;

  async function getCart() {
    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(root + "cart.js");
    return response.json();
  }

  /**
   * Stamp chat_conversation_id onto Shopify cart attributes (same pattern as
   * ProductForm.saveCartAttribution) so checkout_completed can attribute sales
   * without needing customer email.
   */
  async function ensureChatbotCartAttribute(cart) {
    const conversationId = getConversationId();
    if (!conversationId) return;

    const existing = cart && cart.attributes && cart.attributes.chat_conversation_id;
    if (existing === conversationId) return;

    const root = window.Shopify?.routes?.root || "/";
    const mergedAttributes = Object.assign({}, (cart && cart.attributes) || {}, {
      chat_conversation_id: conversationId,
    });

    await fetch(root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ attributes: mergedAttributes }),
    });
  }

  async function saveChatbotCartAttribution() {
    const conversationId = getConversationId();
    if (!conversationId) return Promise.resolve();

    try {
      const cart = await getCart();
      await ensureChatbotCartAttribute(cart);
    } catch (err) {
      console.warn("[chatbot-attribution] failed:", err);
    }
  }

  window.saveChatbotCartAttribution = saveChatbotCartAttribution;

  async function syncCartToBackend() {
    const conversationId = getConversationId();
    if (!conversationId || !socket.connected) return;

    try {
      const cart = await getCart();
      try {
        await ensureChatbotCartAttribute(cart);
      } catch (attrErr) {
        console.warn("[chatbot-attribution] failed:", attrErr);
      }
      socket.emit("cart-update", {
        conversationId,
        cart,
        shopOrigin: window.location.origin,
      });
    } catch (err) {
      console.warn("[cart-sync] failed:", err);
    }
  }

  function scheduleCartSync() {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(syncCartToBackend, 300);
  }

  function isCartModificationUrl(url) {
    return (
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update") ||
      url.includes("/cart/clear")
    );
  }

  function installCartInterceptors() {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = args[0]?.toString() || "";

      if (response.ok && isCartModificationUrl(url)) {
        scheduleCartSync();
      }

      return response;
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._csCartUrl = url?.toString() || "";
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener("load", () => {
        if (this.status >= 200 && this.status < 300 && isCartModificationUrl(this._csCartUrl || "")) {
          scheduleCartSync();
        }
      });
      return originalSend.apply(this, args);
    };

    document.addEventListener("on:cart:add", scheduleCartSync);
    document.addEventListener("on:line-item:change", scheduleCartSync);
  }

  installCartInterceptors();

  // Tell the backend (and all agents) that this customer is active in their conversation
  function announceActive() {
    const conversationId = getConversationId();
    if (conversationId) {
      socket.emit("customer-active", { conversationId });
    }
  }

  // Emit one conversation-level event → single DB write on the backend for all unseen admin messages
  function markConversationSeen() {
    const conversationId = getConversationId();
    if (conversationId) {
      socket.emit("conversation-seen", { conversationId });
    }
  }

  // Page Visibility API: when tab becomes active and chatbot is open, mark all seen
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && isChatOpen) {
      markConversationSeen();
    }
  });

  socket.on("connect", () => {

    console.log(
      "Connected:",
      socket.id
    );

    // Re-announce active status on every (re)connect so agents always see
    // the correct indicator after a page reload or network reconnect
    announceActive();
    scheduleCartSync();
    saveChatbotCartAttribution();

    // Inform server whether chat panel is currently open
    const conversationId = getConversationId();
    if (conversationId) {
      if (isChatOpen) {
        socket.emit("customer-chat-open", { conversationId });
      } else {
        socket.emit("customer-chat-closed", { conversationId });
      }
    }

  });

  socket.on("request-cart-sync", () => {
    scheduleCartSync();
  });

  socket.on(
    "generate-id",
    (data) => {

      const { conversationId } = data;

      localStorage.setItem(
        "chat_conversation_id",
        conversationId
      );

      console.log(
        "Conversation ID stored:",
        conversationId
      );

      scheduleCartSync();
      saveChatbotCartAttribution();

    }
  );

  var hasMoreMessages = false;
  var loadingMore = false;
  var oldestMessageDate = null;
  var historyLoaded = false;

  // --- Initial history load ---
  socket.on("chat-history", function(data) {
    // Support paginated { messages, hasMore } or legacy array
    var history = Array.isArray(data) ? data : data.messages;
    hasMoreMessages = Array.isArray(data) ? false : data.hasMore;

    messages.innerHTML = "";
    lastSender = null;
    lastDateString = null;
    historyLoaded = false;
    loadingMore = false;
    messageStatuses = {};
    greetingSeeded = false;

    if (!history || history.length === 0) return;

    oldestMessageDate = history[0].createdAt;

    history.forEach(function(msg) {
      if (msg.sender === '__system__' || msg.sender === '__feedback__') return; // skip system/feedback notices on customer side
      var deliveryStatus = null;
      if (!msg.fromZendesk && msg.id) {
        deliveryStatus = statusFromDbFields(msg);
      }
      appendMessage(
        msg.fromZendesk ? "agent-message" : "user-message",
        msg.text,
        msg.fromZendesk ? msg.sender : null,
        msg.createdAt ? new Date(msg.createdAt) : null,
        msg.fileId || null,
        msg.fileName || null,
        msg.fileMime || null,
        msg.attachments || null,
        msg.id || null,
        deliveryStatus,
        msg.productSearchMeta || null,
        msg.customerFeedback || null
      );
    });

    if (isChatOpen && document.visibilityState === "visible") {
      markConversationSeen();
    }

    // Scroll to bottom, then enable scroll-up pagination after a short delay
    messages.scrollTop = messages.scrollHeight;
    renderFailedMessages();
    restoreFeedbackCard();
    messages.scrollTop = messages.scrollHeight;
    updateScrollBottomBtn();
    setTimeout(function() { historyLoaded = true; }, 300);
  });

  // --- Older messages loaded on scroll-up ---
  socket.on("more-messages", function(data) {
    if (!data || !data.messages || data.messages.length === 0) {
      hasMoreMessages = false;
      loadingMore = false;
      var loader = messages.querySelector(".chat-loading-more");
      if (loader) loader.remove();
      return;
    }

    hasMoreMessages = data.hasMore;
    oldestMessageDate = data.messages[0].createdAt;

    // Capture scroll state BEFORE any DOM changes
    var heightBefore = messages.scrollHeight;
    var scrollBefore = messages.scrollTop;

    // Now remove the loader
    var loader = messages.querySelector(".chat-loading-more");
    if (loader) loader.remove();

    // Save sender/date tracking (used for new messages at bottom)
    var savedSender = lastSender;
    var savedDate = lastDateString;
    lastSender = null;
    lastDateString = null;

    // Build the older messages into a fragment via the shared appendMessage renderer,
    // so pagination gets the same product carousel / AI header treatment as live messages.
    var fragment = document.createDocumentFragment();

    data.messages.forEach(function(msg) {
      if (msg.sender === '__system__' || msg.sender === '__feedback__') return; // skip system/feedback notices on customer side

      var deliveryStatus = !msg.fromZendesk && msg.id ? statusFromDbFields(msg) : null;

      appendMessage(
        msg.fromZendesk ? "agent-message" : "user-message",
        msg.text,
        msg.fromZendesk ? msg.sender : null,
        msg.createdAt ? new Date(msg.createdAt) : new Date(),
        msg.fileId || null,
        msg.fileName || null,
        msg.fileMime || null,
        msg.attachments || null,
        msg.id || null,
        deliveryStatus,
        msg.productSearchMeta || null,
        msg.customerFeedback || null,
        { target: fragment, skipScroll: true }
      );

      scheduleCartSync();
    });

    // Avoid duplicate date separator between old and existing messages
    var firstDateEl = messages.querySelector(".chat-date-separator");
    if (firstDateEl && firstDateEl.textContent === lastDateString) {
      firstDateEl.remove();
    }

    // Insert older messages at the top
    messages.insertBefore(fragment, messages.firstChild);

    // Restore sender/date tracking
    lastSender = savedSender;
    lastDateString = savedDate;

    // Keep scroll position stable (user sees same content)
    messages.scrollTop = scrollBefore + (messages.scrollHeight - heightBefore);
    loadingMore = false;
    updateScrollBottomBtn();
  });

  // --- Scroll listener: fetch older messages when near top ---
  messages.addEventListener("scroll", function() {
    updateScrollBottomBtn();

    if (!historyLoaded || loadingMore || !hasMoreMessages) return;
    if (messages.scrollTop > 50) return;

    loadingMore = true;
    var conversationId = localStorage.getItem("chat_conversation_id");

    if (!conversationId || !oldestMessageDate) {
      loadingMore = false;
      return;
    }

    // Show a loading indicator at the top
    var loader = document.createElement("div");
    loader.className = "chat-loading-more";
    loader.textContent = "Loading...";
    messages.insertBefore(loader, messages.firstChild);

    socket.emit("load-more-messages", {
      conversationId: conversationId,
      before: oldestMessageDate,
      limit: 10
    });
  });

  socket.on(
    "chat-message",
    ({ id, sender, message, customerMessage, fromZendesk, createdAt, fileId, fileName, fileMime, attachments, productSearchMeta, customerFeedback, contextualFeedback }) => {

      // Skip feedback messages on customer side (they already saw the card)
      if (sender === '__feedback__') return;

      const displayMessage = customerMessage || message;

      appendMessage(
        fromZendesk
          ? "agent-message"
          : "user-message",
        displayMessage,
        fromZendesk ? sender : null,
        createdAt ? new Date(createdAt) : null,
        fileId || null,
        fileName || null,
        fileMime || null,
        attachments || null,
        id || null,
        null,
        productSearchMeta || null,
        customerFeedback || null,
        { contextualFeedback: contextualFeedback || null }
      );

      // Clear typing indicator when message arrives
      clearTypingIndicator();
      // Report delivery/seen status for agent messages (one-way: only agent sees this)
      if (fromZendesk && id) {
        // Always play chime for agent messages
        if (sender !== "System" && sender !== "__feedback__") {
          playChime();
          }
        if (shouldAlertCustomer(sender, fromZendesk)) {
          if (shouldShowBrowserNotification(sender, fromZendesk)) {
            showBrowserNotification({ sender, message: displayMessage, fileName, fileId });
          }
        }

        // Increment unread badge if chat is closed — the server will also emit customer-unread-count
        if (!isChatOpen) {
          var current = unreadBadge && unreadBadge.style.display !== 'none'
            ? (parseInt(unreadBadge.textContent, 10) || 0)
            : 0;
          updateUnreadBadge(current + 1);
        }

        const room = getConversationId();
        if (room) {
          socket.emit("message-delivered", { messageId: id, room });

          if (document.visibilityState === "visible" && isChatOpen) {
            // Bulk-mark via conversation-seen — also covers any other lingering unseen messages
            markConversationSeen();
          }
          // If tab is hidden or chatbot is closed, delivered is enough for now.
          // markConversationSeen() will fire when the customer opens or focuses the chat.
        }
      }

    }
  );

  let typingTimeout;

  socket.on("typing", (username) => {
    if (typeof username === "object" && username?.username === "AI") {
      if (username.lockInput === true) {
        applyAiRespondingLock(true);
        return;
      }
      if (username.lockInput === false) {
        aiResponding = false;
        if (!sendInProgress) setInputDisabled(false);
        return;
      }
    }

    if (typeof username === "object" && username?.clear === true) {
      clearTypingIndicator();
      return;
    }

    if (typeof username === "object" && username?.username && !username.text) {
      clearTypingIndicator();
      return;
    }

    const typingIndicator = document.getElementById("typing-indicator");
    const typingUsername = document.getElementById("typing-username");

    if (!typingIndicator || !typingUsername) return;

    const name = typeof username === "string"
      ? username
      : username?.username || "Support Agent";

    typingUsername.textContent = name;
    typingIndicator.style.display = "flex";

    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(() => {
      typingIndicator.style.display = "none";
    }, 2000);
  });

  function clearTypingIndicator() {
    const typingIndicator = document.getElementById("typing-indicator");
    typingIndicator.style.display = "none";
    clearTimeout(typingTimeout);
  }

  // Unread badge — show count when chat is closed, clear on open
  socket.on("customer-unread-count", ({ count }) => {
    if (!isChatOpen) {
      updateUnreadBadge(count);
    }
  });

  // ── Feedback card ──────────────────────────────────────────
  var feedbackCard = document.getElementById("feedback-card");
  var feedbackId = null;
  var feedbackTimer = null;
  var feedbackSelectedRating = null;
  var feedbackSubmitBtn = document.getElementById("feedback-submit");
  var feedbackStars = document.querySelectorAll(".feedback-star");

  var FEEDBACK_KEY = "chat_feedback_pending";

  function showFeedbackNotice(msg) {
    var footer = document.getElementById("chat-footer");
    if (!footer) return;
    var existing = document.getElementById("chat-feedback-notice");
    if (existing) existing.remove();
    var notice = document.createElement("div");
    notice.id = "chat-feedback-notice";
    notice.className = "chat-feedback-notice";
    notice.textContent = msg;
    footer.insertBefore(notice, footer.firstChild);
    setTimeout(function() { notice.remove(); }, 3500);
  }

  async function downloadChatTranscript() {
    if (transcriptDownloadInProgress) return;

    closeSettingsOverlay();
    var conversationId = getConversationId();
    if (!conversationId) {
      showFeedbackNotice("No chat history to download.");
      return;
    }

    transcriptDownloadInProgress = true;
    renderSettingsPanel();
    showFeedbackNotice("Preparing PDF…");

    try {
      var res = await fetch(
        BACKEND_URL +
          "/transcript/" +
          encodeURIComponent(conversationId) +
          "/pdf"
      );
      if (!res.ok) {
        if (res.status === 404) {
          showFeedbackNotice("No chat history to download.");
        } else {
          showFeedbackNotice("Unable to download chat history. Please try again.");
        }
        return;
      }

      var blob = await res.blob();
      var disposition = res.headers.get("Content-Disposition") || "";
      var filenameMatch = disposition.match(/filename="([^"]+)"/i);
      var filename =
        (filenameMatch && filenameMatch[1]) ||
        "chat-transcript-" + conversationId + ".pdf";

      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () {
        URL.revokeObjectURL(url);
      }, 1000);
    } catch (err) {
      console.error("[downloadChatTranscript]", err);
      showFeedbackNotice("Unable to download chat history. Please try again.");
    } finally {
      transcriptDownloadInProgress = false;
      renderSettingsPanel();
    }
  }

  function openCustomerFeedback() {
    closeSettingsOverlay();
    var conversationId = getConversationId();
    if (!conversationId) {
      showFeedbackNotice("Start a conversation to leave feedback.");
      return;
    }
    if (feedbackCard && feedbackCard.classList.contains("is-open") && feedbackId) {
      return;
    }
    if (!socket.connected) {
      showFeedbackNotice("Unable to open feedback. Please try again.");
      return;
    }
    socket.emit("initiate-feedback", { conversationId }, function(res) {
      if (res && res.feedbackId) {
        showFeedbackCard(res.feedbackId);
        return;
      }
      if (res && res.error === "conversation_closed") {
        showFeedbackNotice("This conversation is closed. Feedback is available when it ends.");
        return;
      }
      showFeedbackNotice("Unable to open feedback. Please try again.");
    });
  }

  function resetFeedbackForm() {
    feedbackSelectedRating = null;
    feedbackStars.forEach(function(s) {
      s.classList.remove("feedback-star--active");
    });
    var commentEl = document.getElementById("feedback-comment");
    if (commentEl) commentEl.value = "";
    if (feedbackSubmitBtn) feedbackSubmitBtn.disabled = true;
  }

  function showFeedbackCard(id) {
    if (!feedbackCard || !id) return;
    resetFeedbackForm();
    feedbackId = id;
    feedbackCard.style.display = "flex";
    feedbackCard.classList.add("is-open");
    feedbackCard.setAttribute("aria-hidden", "false");
    localStorage.setItem(FEEDBACK_KEY, JSON.stringify({
      feedbackId: id,
      shownAt: Date.now()
    }));
    clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(function() { submitFeedback(null); }, 30 * 60 * 1000);
  }

  function hideFeedbackCard() {
    if (!feedbackCard) return;
    feedbackCard.style.display = "none";
    feedbackCard.classList.remove("is-open");
    feedbackCard.setAttribute("aria-hidden", "true");
  }

  function submitFeedback(value) {
    clearTimeout(feedbackTimer);
    feedbackTimer = null;
    localStorage.removeItem(FEEDBACK_KEY);
    if (feedbackId) {
      var comment = document.getElementById("feedback-comment");
      var feedbackComment = comment ? comment.value.trim() : "";
      socket.emit("submit-feedback", {
        feedbackId: feedbackId,
        feedback: value,
        feedbackComment: feedbackComment || null,
      });
    }
    feedbackId = null;
    hideFeedbackCard();
  }

  function restoreFeedbackCard() {
    var stored = localStorage.getItem(FEEDBACK_KEY);
    if (!stored) return;
    try {
      var data = JSON.parse(stored);
      var id = data.feedbackId || data.resolutionTimeId;
      if (!id || (!data.feedbackId && data.resolutionTimeId)) {
        localStorage.removeItem(FEEDBACK_KEY);
        return;
      }
      var remaining = (30 * 60 * 1000) - (Date.now() - data.shownAt);
      if (remaining <= 0) {
        localStorage.removeItem(FEEDBACK_KEY);
        return;
      }
      feedbackId = id;
      if (feedbackCard) {
        feedbackCard.style.display = "flex";
        feedbackCard.classList.add("is-open");
        feedbackCard.setAttribute("aria-hidden", "false");
      }
      clearTimeout(feedbackTimer);
      feedbackTimer = setTimeout(function() { submitFeedback(null); }, remaining);
    } catch (e) {
      localStorage.removeItem(FEEDBACK_KEY);
    }
  }

  socket.on("conversation-closed", function({ roomId, feedbackId: closedFeedbackId }) {
    if (roomId !== getConversationId()) return;
    showFeedbackCard(closedFeedbackId);
  });

  feedbackStars.forEach(function(star) {
    star.addEventListener("mouseenter", function() {
      var val = parseInt(this.dataset.value);
      feedbackStars.forEach(function(s) {
        s.classList.toggle("feedback-star--active", parseInt(s.dataset.value) <= val);
      });
    });
    star.addEventListener("mouseleave", function() {
      // On mouse leave, show the selected rating (if any)
      feedbackStars.forEach(function(s) {
        s.classList.toggle("feedback-star--active", feedbackSelectedRating && parseInt(s.dataset.value) <= feedbackSelectedRating);
      });
    });
    star.addEventListener("click", function() {
      feedbackSelectedRating = parseInt(this.dataset.value);
      feedbackStars.forEach(function(s) {
        s.classList.toggle("feedback-star--active", parseInt(s.dataset.value) <= feedbackSelectedRating);
      });
      if (feedbackSubmitBtn) feedbackSubmitBtn.disabled = false;
    });
  });

  if (feedbackSubmitBtn) {
    feedbackSubmitBtn.addEventListener("click", function() {
      if (feedbackSelectedRating) {
        submitFeedback(feedbackSelectedRating);
        feedbackSelectedRating = null;
      }
    });
  }

  document.getElementById("feedback-dismiss")?.addEventListener("click", function() {
    submitFeedback(null);
    feedbackSelectedRating = null;
  });

  feedbackCard?.querySelector(".feedback-modal-backdrop")?.addEventListener("click", function() {
    submitFeedback(null);
    feedbackSelectedRating = null;
  });
  // ── End feedback card ──────────────────────────────────────

  sendBtn.addEventListener(
    "click",
    sendMessage
  );

  // Auto-resize textarea as user types
  input.addEventListener(
    "input",
    (e) => {
      e.target.style.height = "auto";
      e.target.style.height = e.target.scrollHeight + "px";
      emitUserTyping();
    }
  );

  input.addEventListener(
    "keydown",
    (e) => {

      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
      // Shift+Enter: do nothing — browser inserts newline naturally

    }
  );

  // =========================
  // USER TYPING
  // =========================

  let typingDebounceTimer = null;

  function emitUserTyping(overrideText) {

    const conversationId =
      localStorage.getItem(
        "chat_conversation_id"
      );

    if (!conversationId) {
      return;
    }

    const typingText =
      typeof overrideText === "string"
        ? overrideText
        : input.value;

    clearTimeout(
      typingDebounceTimer
    );

    if (!typingText) {
      socket.emit(
        "user-typing",
        {
          username: "Customer",
          room: conversationId,
          text: ""
        }
      );
      return;
    }

    typingDebounceTimer = setTimeout(
      () => {
        socket.emit(
          "user-typing",
          {
            username: "Customer",
            room: conversationId,
            text: typingText.slice(0, 500)
          }
        );
      },
      250
    );

  }

  // =========================
  // LOAD CHAT HISTORY
  // =========================

  function loadChatHistory() {

    const conversationId =
      localStorage.getItem(
        "chat_conversation_id"
      );

    console.log(
      "loadChatHistory() called, conversationId:",
      conversationId
    );

    if (conversationId) {
      console.log(
        "Requesting chat history for:",
        conversationId
      );

      // Show loading indicator while fetching history
      messages.innerHTML = '<div class="chat-loading" role="status" aria-live="polite"><div class="chat-loading-inner"><div class="chat-loading-ring" aria-hidden="true"><div></div><div></div><div></div><div></div></div><p class="chat-loading-text">Loading your conversation&hellip;</p></div><div class="chat-loading-atmosphere" aria-hidden="true"></div></div>';
      loadingMore = true;

      socket.emit(
        "get-chat-history",
        {
          conversationId
        }
      );
    } else {
      console.log(
        "No conversationId found, skipping history load"
      );
    }

    // Render any persisted failed messages after history loads (handled in chat-history event)
  }

  // =========================
  // INITIALIZE CHAT
  // =========================

  async function fetchCustomerLocation() {
    try {
      const res = await fetch("https://get.geojs.io/v1/ip/geo.json");
      const data = await res.json();
      if (res.status === 200) {
        return { city: data.city || "", country: data.country || "" };
      }
    } catch (err) {
      console.warn("[location] failed to fetch:", err);
    }
    return { city: "", country: "" };
  }

  async function initializeChat(text) {
    const msgEl = appendMessage("user-message", text, null, new Date());

    const location = await fetchCustomerLocation();

    const payload = {
      message: text,
      customerName: customerName,
      fromZendesk: false,
      conversationId:
        localStorage.getItem(
          "chat_conversation_id"
        ) || null,
      pageUrl: cleanPageUrl(window.location.href),
      city: location.city,
      country: location.country
    };

    emitWithRetry(payload, msgEl);
  }

  // =========================
  // RETRY LOGIC & PERSISTENCE
  // =========================

  const ACK_TIMEOUT = 4000;
  const FAILED_MESSAGES_KEY = "chat_failed_messages";
  const FAILED_MSG_MAX_AGE = 24 * 60 * 60 * 1000;

  // Returns all persisted failed messages (auto-discards older than 24h)
  function getFailedMessages() {
    try {
      var msgs = JSON.parse(localStorage.getItem(FAILED_MESSAGES_KEY) || "[]");
      var now = Date.now();
      // Filter out expired messages
      return msgs.filter(function(m) { return (now - m.timestamp) < FAILED_MSG_MAX_AGE; });
    } catch (e) { return []; }
  }

  // Saves a failed message to localStorage (skips duplicates)
  function persistFailed(id, payload, text, createdAt) {
    var msgs = getFailedMessages();
    // Don't store the same message twice
    if (msgs.some(function(m) { return m.id === id; })) return;
    msgs.push({ id: id, payload: payload, text: text, createdAt: createdAt, timestamp: Date.now() });
    localStorage.setItem(FAILED_MESSAGES_KEY, JSON.stringify(msgs));
  }

  // Removes a message from localStorage after successful send
  function removePersisted(id) {
    var msgs = getFailedMessages().filter(function(m) { return m.id !== id; });
    localStorage.setItem(FAILED_MESSAGES_KEY, JSON.stringify(msgs));
  }

  // Removes retry icon, failed text, and sending text from a message container
  function clearRetryUI(container) {
    var icon = container.querySelector(".msg-retry-icon");
    if (icon) icon.remove();
    var text = container.querySelector(".msg-failed-text");
    if (text) text.remove();
    var sending = container.querySelector(".msg-sending-text");
    if (sending) sending.remove();
  }

  // Shows retry icon + "Failed to send" text and persists the failure
  function showRetryUI(msgEl, payload) {
    var container = msgEl.parentNode;
    // Avoid adding duplicate retry UI
    if (container.querySelector(".msg-retry-icon")) return;

    // Assign or reuse a unique ID for this failed message
    var failedId = msgEl.dataset.failedId || ("failed_" + Date.now() + "_" + Math.random().toString(36).slice(2, 6));
    msgEl.dataset.failedId = failedId;
    // Persist so it survives page refresh
    persistFailed(failedId, payload, payload.message, new Date().toISOString());

    // Create retry button with circular arrow icon
    var retryBtn = document.createElement("button");
    retryBtn.className = "msg-retry-icon";
    retryBtn.title = "Retry";
    retryBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>';
    retryBtn.addEventListener("click", function(e) {
      e.stopPropagation(); // Prevent chat from closing
      removePersisted(failedId);
      clearRetryUI(container);
      emitWithRetry(payload, msgEl);
    });
    container.insertBefore(retryBtn, msgEl);

    // Show error text below the bubble
    var failedText = document.createElement("div");
    failedText.className = "msg-failed-text";
    failedText.textContent = "Failed to send";
    container.appendChild(failedText);
  }

  // Emits message to server with ack callback; shows sending/failed state accordingly
  function emitWithRetry(payload, msgEl) {
    // If no connection at all, fail immediately
    if (!navigator.onLine || !socket.connected) {
      msgEl.classList.add("message-failed");
      showRetryUI(msgEl, payload);
      return;
    }

    // Switch to sending state
    msgEl.classList.remove("message-failed");
    msgEl.classList.add("message-sending");
    clearRetryUI(msgEl.parentNode);

    // Show "Sending…" indicator below the bubble
    var sendingText = document.createElement("div");
    sendingText.className = "msg-sending-text";
    sendingText.textContent = "Sending…";
    msgEl.parentNode.appendChild(sendingText);

    // If no ack within timeout, treat as failed
    var timeout = setTimeout(function() {
      msgEl.classList.remove("message-sending");
      msgEl.classList.add("message-failed");
      clearRetryUI(msgEl.parentNode);
      showRetryUI(msgEl, payload);
    }, ACK_TIMEOUT);

    // Browser-session contextual prompt budget for the backend gate
    payload.contextualSessionShownCount = getContextualSessionShownCount();

    // Emit with ack callback
    socket.emit("send_shopify_message", payload, function(response) {
      clearTimeout(timeout);
      if (response && response.ok) {
        // Success — clean up all retry/sending UI
        msgEl.classList.remove("message-sending", "message-failed");
        clearRetryUI(msgEl.parentNode);
        if (msgEl.dataset.failedId) {
          removePersisted(msgEl.dataset.failedId);
          delete msgEl.dataset.failedId;
        }
        if (response.id) {
          var container = msgEl.parentNode;
          container.dataset.messageId = response.id;
          var meta = container.querySelector(".msg-meta-me");
          if (!meta) {
            var timeStr = new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit", hour12: true });
            finishUserContainer(container, timeStr, response.id, "sent");
          } else if (!meta.querySelector(".msg-ticks")) {
            messageStatuses[response.id] = "sent";
            meta.appendChild(createDeliveryTicks("sent"));
          } else {
            applyMessageStatus(response.id, "sent");
          }
        }
      } else if (response && response.error === "ai_responding") {
        msgEl.classList.remove("message-sending", "message-failed");
        clearRetryUI(msgEl.parentNode);
        msgEl.remove();
      } else {
        // Server responded with error
        msgEl.classList.remove("message-sending");
        msgEl.classList.add("message-failed");
        clearRetryUI(msgEl.parentNode);
        showRetryUI(msgEl, payload);
      }
    });
  }

  // Restores persisted failed messages from localStorage on page load
  function renderFailedMessages() {
    getFailedMessages().forEach(function(m) {
      var msgEl = appendMessage("user-message", m.text, null, new Date(m.createdAt));
      msgEl.dataset.failedId = m.id;
      msgEl.classList.add("message-failed");
      showRetryUI(msgEl, m.payload);
    });
  }

  // =========================
  // SEND CHAT MESSAGE
  // =========================

  async function sendMessage() {
  const text = input.value.trim();

  if (!text && !pendingFiles.length) return;
  if (aiResponding) return;

  // Only gate brand-new chats; existing conversationId means the customer already onboarded
  if (!customerName && !localStorage.getItem("chat_conversation_id")) {
    pendingSend = { type: "message" };
    openNameModal();
    return;
  }

  unlockChime();

  sendInProgress = true;
  setInputDisabled(true);

  const conversationId =
    localStorage.getItem("chat_conversation_id") || null;
  const isNewConversation = !conversationId;

  try {
    if (pendingFiles.length) {
      const filesToSend = [...pendingFiles];
      clearPendingFiles();

      // Upload all files at once
      const uploadedAttachments = await uploadFiles(filesToSend, conversationId || "unknown");

      // Show optimistic message with all images in one bubble
      const msgEl = appendMessage(
        "user-message",
        text,
        null,
        new Date(),
        null, null, null,
        uploadedAttachments
      );

      const payload = {
        message: text,
        customerName: isNewConversation ? customerName : null,
        fromZendesk: false,
        conversationId,
        pageUrl: cleanPageUrl(window.location.href),
        // Legacy: first file for backward compat
        fileId: uploadedAttachments[0]?.fileId,
        fileS3Key: uploadedAttachments[0]?.fileS3Key,
        fileName: uploadedAttachments[0]?.fileName,
        fileMime: uploadedAttachments[0]?.fileMime,
        fileSize: uploadedAttachments[0]?.fileSize,
        // New: full attachments array
        attachments: uploadedAttachments,
      };

      emitWithRetry(payload, msgEl);
    } else if (isNewConversation) {
      // First text message of a brand-new conversation — fetch location too
      await initializeChat(text);
    } else {
      // Text-only message
      const msgEl = appendMessage(
        "user-message",
        text,
        null,
        new Date()
      );

      const payload = {
        message: text,
        customerName: null,
        fromZendesk: false,
        conversationId,
        pageUrl: cleanPageUrl(window.location.href),
      };

      emitWithRetry(payload, msgEl);
    }

    input.value = "";
    input.style.height = "auto";
    emitUserTyping("");
  } catch (err) {
    alert("Failed to upload image: " + err.message);
  } finally {
    sendInProgress = false;
    if (!aiResponding) setInputDisabled(false);
  }
}

  // =========================
  // MESSAGE UI
  // =========================

  // Matches emails, https?:// URLs, OR bare domains (e.g. behope.ca, www.chatgpt.com)
  const URL_REGEX = /(?:[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}|https?:\/\/(?:[^\s<>"']+)|(?:www\.|(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:com|ca|org|net|io|co|app|dev|ai|shop|store))(?:[^\s<>"'()]*[^\s<>"'().,;:!?)])?)/gi;
  const MD_LINK_REGEX = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g;

  // Strips trailing sentence punctuation that was captured as part of a URL
  function trimUrlPunctuation(url) {
    return url.replace(/[.,;:!?)]+$/, "");
  }

  // Returns a full href — emails get mailto:, bare domains get https://
  function toHref(url) {
    if (/^[a-zA-Z0-9._%+\-]+@/.test(url)) return "mailto:" + url;
    return /^https?:\/\//i.test(url) ? url : "https://" + url;
  }

  function appendBareUrlLinks(text, fragment) {
    let lastIndex = 0;
    let match;
    URL_REGEX.lastIndex = 0;

    while ((match = URL_REGEX.exec(text)) !== null) {
      const raw = trimUrlPunctuation(match[0]);
      const start = match.index;
      const end = match.index + raw.length;

      if (start > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, start)));
      }

      const a = document.createElement("a");
      a.href = toHref(raw);
      a.textContent = raw;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.className = /^[a-zA-Z0-9._%+\-]+@/.test(raw) ? "chat-link chat-link--email" : "chat-link";
      fragment.appendChild(a);

      lastIndex = end;
      URL_REGEX.lastIndex = lastIndex;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }
  }

  // Splits text into plain text, markdown links, and bare URLs as a DocumentFragment
  function linkifyText(text) {
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;
    MD_LINK_REGEX.lastIndex = 0;

    while ((match = MD_LINK_REGEX.exec(text)) !== null) {
      const label = match[1];
      const url = match[2];
      const start = match.index;
      const end = match.index + match[0].length;

      if (start > lastIndex) {
        appendBareUrlLinks(text.slice(lastIndex, start), fragment);
      }

      const a = document.createElement("a");
      a.href = url;
      a.textContent = label;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.className = "chat-link";
      fragment.appendChild(a);

      lastIndex = end;
    }

    if (lastIndex < text.length) {
      appendBareUrlLinks(text.slice(lastIndex), fragment);
    }

    return fragment;
  }

  // Escape HTML before we re-introduce a small, explicit markdown subset.
  function escapeHtml(str) {
    if (str === null || str === undefined) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  // Linkifies bare http(s) URLs in HTML that is not already inside an anchor tag.
  function autoLinkBareUrls(html) {
    return html.replace(/(^|[^"'>])((?:https?:\/\/)[^\s<]+[^\s<.,;:!?)\]])/g, function (_m, pre, url) {
      return pre + '<a class="chat-link" href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>";
    });
  }

  // Renders a safe markdown subset for AI/agent bubbles: bold, italic, lists, links.
  function renderMarkdown(src) {
    if (!src) return "";
    var input = String(src).replace(/\r\n/g, "\n");

    var codeBlocks = [];
    input = input.replace(/```([a-zA-Z0-9_-]*)\n([\s\S]*?)```/g, function (_m, _lang, body) {
      codeBlocks.push(body);
      return "\u0000CODEBLOCK" + (codeBlocks.length - 1) + "\u0000";
    });

    var escaped = escapeHtml(input);

    var inlineCodes = [];
    escaped = escaped.replace(/`([^`\n]+)`/g, function (_m, code) {
      inlineCodes.push(code);
      return "\u0000ICODE" + (inlineCodes.length - 1) + "\u0000";
    });

    escaped = escaped.replace(/\*\*([^*\n]+)\*\*/g, "<strong>$1</strong>");
    escaped = escaped.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, "$1<em>$2</em>");

    escaped = escaped.replace(/\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_m, label, url) {
      return '<a class="chat-link" href="' + url + '" target="_blank" rel="noopener noreferrer">' + label + "</a>";
    });

    escaped = autoLinkBareUrls(escaped);

    var lines = escaped.split("\n");
    var out = [];
    var inUl = false;
    var inOl = false;
    var paraBuf = [];

    function flushPara() {
      if (paraBuf.length) {
        out.push("<p>" + paraBuf.join("<br>") + "</p>");
        paraBuf = [];
      }
    }
    function closeLists() {
      if (inUl) { out.push("</ul>"); inUl = false; }
      if (inOl) { out.push("</ol>"); inOl = false; }
    }

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var trimmed = line.replace(/^\s+/, "");
      var ulMatch = trimmed.match(/^[-*]\s+(.+)$/);
      var olMatch = trimmed.match(/^(\d+)\.\s+(.+)$/);
      var hMatch = trimmed.match(/^(#{1,3})\s+(.+)$/);

      if (hMatch) {
        flushPara(); closeLists();
        var level = hMatch[1].length;
        out.push("<h" + level + ">" + hMatch[2] + "</h" + level + ">");
      } else if (ulMatch) {
        flushPara();
        if (inOl) { out.push("</ol>"); inOl = false; }
        if (!inUl) { out.push("<ul>"); inUl = true; }
        out.push("<li>" + ulMatch[1] + "</li>");
      } else if (olMatch) {
        flushPara();
        if (inUl) { out.push("</ul>"); inUl = false; }
        if (!inOl) { out.push("<ol>"); inOl = true; }
        out.push("<li>" + olMatch[2] + "</li>");
      } else if (trimmed === "") {
        flushPara(); closeLists();
      } else {
        if (inUl || inOl) closeLists();
        paraBuf.push(line);
      }
    }
    flushPara();
    closeLists();

    var html = out.join("");

    html = html.replace(/\u0000ICODE(\d+)\u0000/g, function (_m, idx) {
      return "<code>" + escapeHtml(inlineCodes[Number(idx)]) + "</code>";
    });
    html = html.replace(/\u0000CODEBLOCK(\d+)\u0000/g, function (_m, idx) {
      return "<pre><code>" + escapeHtml(codeBlocks[Number(idx)]) + "</code></pre>";
    });

    return html;
  }

  // AI/agent messages get markdown; customer messages stay plain + linkified.
  function fillMessageText(textSpan, displayText, useMarkdown) {
    textSpan.className = "message-text" + (useMarkdown ? " message-text--md" : "");
    if (useMarkdown) {
      textSpan.innerHTML = renderMarkdown(displayText);
    } else {
      textSpan.appendChild(linkifyText(displayText));
    }
  }

  let lastSender = null;
  let lastDateString = null;

  function formatDateBlock(date) {
    const d = new Date(date);
    const now = new Date();
    if (d.toDateString() === now.toDateString()) return "Today";
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
    return d.toLocaleDateString([], { day: "numeric", month: "long", year: "numeric" });
  }

  function insertDateSeparator(date, target) {
    const dateStr = formatDateBlock(date);
    if (dateStr === lastDateString) return;
    lastDateString = dateStr;

    const separator = document.createElement("div");
    separator.className = "chat-date-separator";
    separator.textContent = dateStr;
    (target || messages).appendChild(separator);
  }

  // Builds the little "AI" icon + label row shown inside AI-authored bubbles
  function buildAiMessageHeader() {
    const header = document.createElement("div");
    header.className = "ai-message-header";

    const icon = document.createElement("span");
    icon.className = "ai-message-header-icon";
    const iconGlyph = document.createElement("span");
    iconGlyph.className = "material-symbols-outlined";
    iconGlyph.setAttribute("aria-hidden", "true");
    iconGlyph.textContent = "smart_toy";
    icon.appendChild(iconGlyph);

    const label = document.createElement("span");
    label.className = "ai-message-header-label";
    label.textContent = "AI";

    header.appendChild(icon);
    header.appendChild(label);
    return header;
  }

  // Formats a product price with a currency suffix inferred from the search region
  function formatProductPrice(price, region) {
    if (price === null || price === undefined || price === "") return "";
    const suffix = region === "CA" ? " CAD" : region === "US" ? " USD" : "";
    const num = typeof price === "number" ? price : parseFloat(price);
    if (!isNaN(num)) return "$" + num.toFixed(2) + suffix;
    return String(price) + suffix;
  }

  // When product cards are shown, drop catalog dump lines (product name/price/URL rows).
  // Keep prose and attribute lists (colors, sizes, etc.) that cards do not show.
  function stripProductCatalogFromText(text, meta) {
    if (!text || !meta || !meta.products || !meta.products.length) return text || "";

    var productNames = meta.products
      .map(function (p) { return (p.name || "").trim().toLowerCase(); })
      .filter(Boolean);
    var productUrls = meta.products
      .map(function (p) { return (p.url || "").trim().toLowerCase(); })
      .filter(Boolean);

    function lineMatchesProductMeta(lower) {
      for (var n = 0; n < productNames.length; n++) {
        if (productNames[n] && lower.indexOf(productNames[n]) !== -1) return true;
      }
      for (var u = 0; u < productUrls.length; u++) {
        if (productUrls[u] && lower.indexOf(productUrls[u]) !== -1) return true;
      }
      return false;
    }

    function isCatalogLinkOrPriceLine(trimmed) {
      if (/\[[^\]]+\]\(https?:\/\/[^)]+\)/i.test(trimmed)) return true;
      if (/https?:\/\//i.test(trimmed)) return true;
      if (/\/products\//i.test(trimmed)) return true;
      if (/\bview\s+product\b/i.test(trimmed)) return true;
      if (/\$\s*\d/.test(trimmed)) return true;
      return false;
    }

    var lines = String(text).split(/\r?\n/);
    var kept = [];

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var trimmed = line.trim();
      if (!trimmed) {
        kept.push("");
        continue;
      }

      var listMatch = trimmed.match(/^(?:[-*•]|\d+[\.)])\s+(.*)$/);
      var isListItem = !!listMatch;
      var content = isListItem ? listMatch[1].trim() : trimmed;
      var contentLower = content.toLowerCase();

      // Always drop pure catalog markers (links, prices, "View Product")
      if (isCatalogLinkOrPriceLine(trimmed) || isCatalogLinkOrPriceLine(content)) continue;

      // List items that name a card product are redundant with the carousel
      if (isListItem && lineMatchesProductMeta(contentLower)) continue;

      kept.push(line);
    }

    return kept.join("\n").replace(/\n{3,}/g, "\n\n").trim();
  }

  // Builds the horizontally-scrollable product carousel shown under AI product-search replies
  function buildProductCarousel(meta) {
    if (!meta || !meta.products || !meta.products.length) return null;

    const carousel = document.createElement("div");
    carousel.className = "cs-product-carousel";

    meta.products.forEach((product) => {
      const card = document.createElement("a");
      card.className = "cs-product-card";
      card.href = product.url || "#";
      card.target = "_blank";
      card.rel = "noopener noreferrer";

      if (product.image) {
        const img = document.createElement("img");
        img.className = "cs-product-card-image";
        img.src = product.image;
        img.alt = product.name || "Product";
        img.loading = "lazy";
        card.appendChild(img);
      } else {
        const placeholder = document.createElement("div");
        placeholder.className = "cs-product-card-image";
        card.appendChild(placeholder);
      }

      const title = document.createElement("div");
      title.className = "cs-product-card-title";
      title.textContent = product.name || "";
      card.appendChild(title);

      const price = formatProductPrice(product.price, meta.region);
      if (price) {
        const priceEl = document.createElement("div");
        priceEl.className = "cs-product-card-price";
        priceEl.textContent = price;
        card.appendChild(priceEl);
      }

      const btn = document.createElement("span");
      btn.className = "cs-product-card-btn";
      btn.textContent = "View Product";
      card.appendChild(btn);

      carousel.appendChild(card);
    });

    return carousel;
  }

  function buildSearchUrl(meta) {
    if (!meta || !meta.searchQuery) return null;
    var url = "/search?q=" + encodeURIComponent(meta.searchQuery);
    if (meta.region) url += "&region=" + encodeURIComponent(meta.region);
    return url;
  }

  function attachShowAllLink(container, meta) {
    if (!container || !meta || !meta.searchQuery || !(meta.totalSize > 5)) return;
    var href = buildSearchUrl(meta);
    if (!href) return;
    var link = document.createElement("a");
    link.className = "cs-show-all-results";
    link.href = href;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    var label = document.createElement("span");
    label.textContent = "Show all " + meta.totalSize + " results";
    link.appendChild(label);

    var chevron = document.createElement("span");
    chevron.className = "material-symbols-outlined cs-show-all-chevron";
    chevron.setAttribute("aria-hidden", "true");
    chevron.textContent = "chevron_right";
    link.appendChild(chevron);

    container.appendChild(link);
  }

  function isMessageFeedbackEligible(sender, isAgentMessage) {
    if (!isAgentMessage) return false;
    if (!sender || sender === "System" || sender === "__system__" || sender === "__feedback__") return false;
    return true;
  }

  function setThumbsActive(row, feedback) {
    if (!row) return;
    var upBtn = row.querySelector('[data-feedback="up"]');
    var downBtn = row.querySelector('[data-feedback="down"]');
    if (upBtn) upBtn.classList.toggle("is-active", feedback === "up");
    if (downBtn) downBtn.classList.toggle("is-active", feedback === "down");
    row.dataset.feedback = feedback || "";
  }

  function submitMessageFeedback(messageId, feedback, row) {
    var conversationId = getConversationId();
    if (!messageId || !conversationId || (feedback !== "up" && feedback !== "down")) return;

    // Clicking the active thumb again clears feedback
    var previous = row ? (row.dataset.feedback || null) : null;
    var nextFeedback = previous === feedback ? null : feedback;
    setThumbsActive(row, nextFeedback);

    socket.emit(
      "message-feedback",
      { messageId: messageId, conversationId: conversationId, feedback: nextFeedback },
      function (res) {
        if (!res || res.error) {
          setThumbsActive(row, previous);
          console.warn("[message-feedback] failed:", res && res.error);
        } else {
          setThumbsActive(row, res.customerFeedback || null);
        }
      }
    );
  }

  function createMessageFeedbackRow(messageId, customerFeedback) {
    var row = document.createElement("div");
    row.className = "message-feedback";
    row.dataset.messageId = messageId;

    function makeBtn(value, label, svgPath) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "message-feedback-btn";
      btn.dataset.feedback = value;
      btn.setAttribute("aria-label", label);
      btn.title = label;
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="currentColor">' +
        svgPath +
        "</svg>";
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitMessageFeedback(messageId, value, row);
      });
      return btn;
    }

    // Material-style thumb up / thumb down paths
    row.appendChild(
      makeBtn(
        "up",
        "Thumbs up",
        '<path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>'
      )
    );
    row.appendChild(
      makeBtn(
        "down",
        "Thumbs down",
        '<path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"/>'
      )
    );

    if (customerFeedback === "up" || customerFeedback === "down") {
      setThumbsActive(row, customerFeedback);
    }
    return row;
  }

  function attachMessageFeedback(container, messageId, sender, customerFeedback) {
    if (!container || !messageId || !isMessageFeedbackEligible(sender, true)) return;
    container.dataset.messageId = messageId;
    var existing = container.querySelector(".message-feedback");
    if (existing) {
      setThumbsActive(existing, customerFeedback);
      return;
    }
    container.appendChild(createMessageFeedbackRow(messageId, customerFeedback));
  }

  var CONTEXTUAL_SESSION_KEY = "cs_contextual_feedback_v1";
  // TESTING: was 2 — allow many prompts per browser session; restore before ship
  var CONTEXTUAL_SESSION_MAX = 100;
  var renderedContextualPromptIds = {};
  var contextualFeedbackCard = document.getElementById("contextual-feedback-card");
  var contextualFeedbackBody = document.getElementById("contextual-feedback-body");
  var activeContextualInlineCard = null;

  function getContextualSessionShownCount() {
    try {
      var raw = sessionStorage.getItem(CONTEXTUAL_SESSION_KEY);
      if (!raw) return 0;
      var parsed = JSON.parse(raw);
      var count = Number(parsed && parsed.shownCount);
      if (!Number.isFinite(count) || count < 0) return 0;
      return Math.min(CONTEXTUAL_SESSION_MAX, count);
    } catch (e) {
      return 0;
    }
  }

  function incrementContextualSessionShownCount() {
    var next = Math.min(CONTEXTUAL_SESSION_MAX, getContextualSessionShownCount() + 1);
    try {
      sessionStorage.setItem(
        CONTEXTUAL_SESSION_KEY,
        JSON.stringify({
          shownCount: next,
          updatedAt: new Date().toISOString(),
        })
      );
    } catch (e) {
      console.warn("[contextual-feedback] sessionStorage unavailable:", e);
    }
    return next;
  }

  function closeContextualFeedbackModal() {
    if (!contextualFeedbackCard) return;
    contextualFeedbackCard.classList.remove("is-open");
    contextualFeedbackCard.style.display = "none";
    contextualFeedbackCard.setAttribute("aria-hidden", "true");
    if (contextualFeedbackBody) contextualFeedbackBody.innerHTML = "";
  }

  function openContextualFeedbackModalShell() {
    if (!contextualFeedbackCard) return;
    contextualFeedbackCard.style.display = "flex";
    contextualFeedbackCard.classList.add("is-open");
    contextualFeedbackCard.setAttribute("aria-hidden", "false");
  }

  function showContextualThanksInline(card) {
    if (!card) return;
    card.innerHTML = "";
    card.classList.remove("contextual-feedback--pending");
    card.classList.add("contextual-feedback--thanks");
    var thanks = document.createElement("div");
    thanks.className = "contextual-feedback-thanks";
    thanks.textContent = "Thanks for your feedback!";
    card.appendChild(thanks);
  }

  /** Immediate thanks UI; submit runs in the background. */
  function finishContextualOptimistic(card, payload) {
    closeContextualFeedbackModal();
    activeContextualInlineCard = null;
    showContextualThanksInline(card);
    submitContextualFeedback(payload, null, null);
  }

  function finishContextualSubmit(card) {
    closeContextualFeedbackModal();
    showContextualThanksInline(card || activeContextualInlineCard);
    activeContextualInlineCard = null;
  }

function submitContextualFeedback(payload, card, unlockBtns) {
    if (!payload.conversationId) {
      payload.conversationId = getConversationId();
    }
    if (!payload.conversationId || !payload.feedbackPromptId) {
      console.warn("[contextual-feedback] missing conversationId or promptId");
      if (typeof unlockBtns === "function") unlockBtns();
      if (card) showFeedbackNotice("Could not send feedback. Please try again.");
      return;
    }

    var settled = false;
    var unlockTimer = setTimeout(function () {
      if (settled) return;
      settled = true;
      console.warn("[contextual-feedback] submit timed out");
      if (typeof unlockBtns === "function") unlockBtns();
      if (card) showFeedbackNotice("Could not send feedback. Please try again.");
    }, 10000);

    socket.emit("submit-contextual-feedback", payload, function (res) {
      if (settled) return;
      settled = true;
      clearTimeout(unlockTimer);
      if (!res || res.error) {
        console.warn("[contextual-feedback] failed:", res && res.error);
        if (typeof unlockBtns === "function") unlockBtns();
        if (card) showFeedbackNotice("Could not send feedback. Please try again.");
        return;
      }
      // When card is null, UI already closed optimistically (Submit/Skip on Tell us more)
      if (card) finishContextualSubmit(card);
    });
  }

  function renderContextualSomethingElseStep(basePayload, inlineCard) {
    if (!contextualFeedbackBody) return;
    contextualFeedbackBody.innerHTML = "";

    var heading = document.createElement("p");
    heading.id = "contextual-feedback-heading";
    heading.className = "feedback-heading";
    heading.textContent = "Tell us more…";
    contextualFeedbackBody.appendChild(heading);

    var input = document.createElement("textarea");
    input.className = "feedback-comment contextual-feedback-detail-input";
    input.rows = 4;
    input.maxLength = 500;
    input.placeholder = "Optional details";
    input.addEventListener("click", function (e) { e.stopPropagation(); });
    input.addEventListener("mousedown", function (e) { e.stopPropagation(); });
    contextualFeedbackBody.appendChild(input);

    var actions = document.createElement("div");
    actions.className = "contextual-feedback-modal-actions contextual-feedback-modal-actions--stack";

    var submitBtn = document.createElement("button");
    submitBtn.type = "button";
    submitBtn.className = "feedback-submit-btn";
    submitBtn.textContent = "Submit";
    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      submitBtn.disabled = true;
      skipBtn.disabled = true;
      finishContextualOptimistic(
        inlineCard,
        Object.assign({}, basePayload, {
          rating: "negative",
          reason: "something_else",
          detail: (input.value || "").trim() || null,
        })
      );
    });

    var skipBtn = document.createElement("button");
    skipBtn.type = "button";
    skipBtn.className = "contextual-feedback-skip-btn";
    skipBtn.textContent = "Skip";
    skipBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Skip = close immediately; still record "something else" with no detail
      finishContextualOptimistic(
        inlineCard,
        Object.assign({}, basePayload, {
          rating: "negative",
          reason: "something_else",
          detail: null,
        })
      );
    });

    actions.appendChild(submitBtn);
    actions.appendChild(skipBtn);
    contextualFeedbackBody.appendChild(actions);
    setTimeout(function () {
      try { input.focus(); } catch (err) { /* ignore */ }
    }, 0);
  }

  // Popup only after "Not quite" — reason chips / something else
  function openContextualReasonsPopup(feedback, basePayload, inlineCard) {
    if (!contextualFeedbackCard || !contextualFeedbackBody) return;
    activeContextualInlineCard = inlineCard || null;
    contextualFeedbackBody.innerHTML = "";

    var heading = document.createElement("p");
    heading.id = "contextual-feedback-heading";
    heading.className = "feedback-heading";
    heading.textContent = "What was missing?";
    contextualFeedbackBody.appendChild(heading);

    var chips = document.createElement("div");
    chips.className = "contextual-feedback-modal-reasons";

    (feedback.reasons || []).forEach(function (reason) {
      var chip = document.createElement("button");
      chip.type = "button";
      chip.className = "contextual-feedback-chip";
      chip.textContent = reason.label || reason.code;
      chip.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (reason.code === "something_else") {
          renderContextualSomethingElseStep(basePayload, inlineCard);
          return;
        }
        chip.disabled = true;
        finishContextualOptimistic(
          inlineCard,
          Object.assign({}, basePayload, {
            rating: "negative",
            reason: reason.code,
          })
        );
      });
      chips.appendChild(chip);
    });

    contextualFeedbackBody.appendChild(chips);
    openContextualFeedbackModalShell();
  }

  // Inline Yes / Not quite under the AI message; popup only for negative reasons
  function attachContextualFeedback(container, messageId, feedback) {
    if (!container || !feedback || !feedback.enabled || !feedback.feedbackPromptId) return;
    if (renderedContextualPromptIds[feedback.feedbackPromptId]) return;
    if (getContextualSessionShownCount() >= CONTEXTUAL_SESSION_MAX) return;
    if (container.querySelector(".contextual-feedback")) return;

    renderedContextualPromptIds[feedback.feedbackPromptId] = true;
    incrementContextualSessionShownCount();
    if (messageId) container.dataset.messageId = messageId;

    var card = document.createElement("div");
    card.className = "contextual-feedback";
    card.dataset.promptId = feedback.feedbackPromptId;
    if (messageId) card.dataset.messageId = messageId;

    var question = document.createElement("div");
    question.className = "contextual-feedback-question";
    question.textContent = feedback.question || "Was this helpful?";
    card.appendChild(question);

    var actions = document.createElement("div");
    actions.className = "contextual-feedback-actions";

    var basePayload = {
      conversationId: getConversationId(),
      messageId: messageId || feedback.messageId || null,
      feedbackPromptId: feedback.feedbackPromptId,
      context: feedback.context,
      topic: feedback.topic || null,
    };

    var yesBtn = document.createElement("button");
    yesBtn.type = "button";
    yesBtn.className = "contextual-feedback-btn contextual-feedback-btn--positive";
    yesBtn.textContent = feedback.positiveLabel || "Yes";
    yesBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      yesBtn.disabled = true;
      noBtn.disabled = true;
      finishContextualOptimistic(
        card,
        Object.assign({}, basePayload, { rating: "positive" })
      );
    });

    var noBtn = document.createElement("button");
    noBtn.type = "button";
    noBtn.className = "contextual-feedback-btn contextual-feedback-btn--negative";
    noBtn.textContent = feedback.negativeLabel || "Not quite";
    noBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      openContextualReasonsPopup(feedback, basePayload, card);
    });

    actions.appendChild(yesBtn);
    actions.appendChild(noBtn);
    card.appendChild(actions);
    container.appendChild(card);
    try {
      card.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } catch (e) { /* ignore */ }
  }

  if (contextualFeedbackCard) {
    contextualFeedbackCard.addEventListener("click", function (e) {
      e.stopPropagation();
    });
    contextualFeedbackCard.querySelectorAll("[data-contextual-dismiss]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeContextualFeedbackModal();
      });
    });
  }

  function appendMessage(
    className,
    text,
    username = null,
    timestamp = null,
    fileId = null,
    fileName = null,
    fileMime = null,
    attachments = null,
    messageId = null,
    deliveryStatus = null,
    productSearchMeta = null,
    customerFeedback = null,
    options = null
  ) {

    const opts = options || {};
    const target = opts.target || messages;
    const contextualFeedback = opts.contextualFeedback || null;

    // Normalize attachments: combine legacy single-file with new array format
    const allAttachments = attachments && attachments.length > 0
      ? attachments
      : (fileId ? [{ fileId, fileName, fileMime }] : []);

    const isUserMsg = className === "user-message";
    const isAiMsg = username === "AI";

    // Prefer product cards over duplicate catalog dumps in AI text
    let displayText = text;
    if (!isUserMsg && productSearchMeta && productSearchMeta.products && productSearchMeta.products.length) {
      displayText = stripProductCatalogFromText(text, productSearchMeta);
    }

    // Insert date block if day changed
    const msgDate = timestamp || new Date();
    insertDateSeparator(msgDate, target);

    const container = document.createElement("div");
    container.className = "message-container message-container--" + (isUserMsg ? "user" : "agent");

    // Reset lastSender when user sends a message (so next agent message shows name)
    if (isUserMsg) {
      lastSender = null;
    }

    // Add username label only if sender changed (for human agent messages) — AI uses ai-message-header instead
    const shouldShowUsername = username && username !== lastSender && !isAiMsg;
    if (shouldShowUsername || isAiMsg) {
      lastSender = username;
    }

    // Format time as "10:45 AM" - use provided timestamp or current time
    const timeDate = timestamp || new Date();
    const timeString = timeDate.toLocaleTimeString([], { hour: "numeric", minute: "2-digit", hour12: true });

    const timeEl = document.createElement("span");
    timeEl.className = "message-time";
    timeEl.textContent = timeString;

    if (shouldShowUsername) {
      const usernameLabel = document.createElement("div");
      usernameLabel.className = "message-username";
      usernameLabel.textContent = username;
      container.appendChild(usernameLabel);
    }

    const div = document.createElement("div");
    div.className = `message ${className}`;
    if (isAiMsg) {
      div.classList.add("ai-message");
      div.appendChild(buildAiMessageHeader());
    }

    // Render images from attachments array
    const imageAttachments = allAttachments.filter(a => isImageAttachment(a));
    const pdfAttachments = allAttachments.filter(a => a.fileId && a.fileMime === "application/pdf");
    const hasImages = imageAttachments.length > 0;

    if (hasImages) {
      div.classList.add("message--has-image");
      const imageGrid = document.createElement("div");
      imageGrid.className = "message-image-grid" + (imageAttachments.length > 1 ? " message-image-grid--multi" : "");
      imageAttachments.forEach(att => {
        const img = document.createElement("img");
        // Prefer CDN/signed url (Giphy or upload), fall back to /files/ for history
        img.src = attachmentImageSrc(att);
        img.alt = att.fileName || "image";
        img.className = "message-image";
        img.addEventListener("click", () => window.open(img.src, "_blank"));
        imageGrid.appendChild(img);
      });
      div.appendChild(imageGrid);
    }

    pdfAttachments.forEach(att => {
      const pdfLink = document.createElement("a");
      pdfLink.href = `${BACKEND_URL}/files/${encodeURIComponent(att.fileId)}`;
      pdfLink.target = "_blank";
      pdfLink.rel = "noopener noreferrer";
      pdfLink.className = "message-pdf-link";
      pdfLink.textContent = "📄 " + (att.fileName || "document.pdf");
      div.appendChild(pdfLink);
    });

    if (displayText) {
      if (hasImages) {
        const textBlock = document.createElement("div");
        textBlock.className = "message-text-block";
        const textSpan = document.createElement("span");
        fillMessageText(textSpan, displayText, !isUserMsg);
        textBlock.appendChild(textSpan);
        div.appendChild(textBlock);
      } else if (isUserMsg) {
        const bottomRow = document.createElement("div");
        bottomRow.className = "message-bottom";
        const textSpan = document.createElement("span");
        fillMessageText(textSpan, displayText, false);
        bottomRow.appendChild(textSpan);
        div.appendChild(bottomRow);
      } else {
        const bottomRow = document.createElement("div");
        bottomRow.className = "message-bottom";
        const textSpan = document.createElement("span");
        fillMessageText(textSpan, displayText, true);
        bottomRow.appendChild(textSpan);
        bottomRow.appendChild(timeEl);
        div.appendChild(bottomRow);
      }
    } else if (!hasImages && !isUserMsg) {
      const bottomRow = document.createElement("div");
      bottomRow.className = "message-bottom";
      bottomRow.appendChild(timeEl);
      div.appendChild(bottomRow);
    }

    // Product carousel lives inside the AI/agent bubble to match Figma
    if (!isUserMsg) {
      const carousel = buildProductCarousel(productSearchMeta);
      if (carousel) div.appendChild(carousel);
      attachShowAllLink(div, productSearchMeta);
    }

    container.appendChild(div);

    if (isUserMsg) {
      finishUserContainer(container, timeString, messageId, deliveryStatus);
    } else if (hasImages) {
      timeEl.classList.add("message-time--outside");
      container.appendChild(timeEl);
    }

    if (!isUserMsg) {
      if (contextualFeedback && contextualFeedback.enabled) {
        attachContextualFeedback(container, messageId, contextualFeedback);
      } else {
        attachMessageFeedback(container, messageId, username, customerFeedback);
      }
    }

    target.appendChild(container);

    if (!opts.skipScroll) {
      scrollMessagesToBottom();
      if (hasImages) bindImageScroll(container);
    }

    return div;
  }

  // =========================
  // CAMPAIGN DEEP LINK (#open-chat)
  // Opens the chatbot when marketing links land on e.g. https://behope.ca/#open-chat
  // =========================

  var OPEN_CHAT_HASH = "#open-chat";

  function consumeOpenChatHash() {
    if (String(window.location.hash || "").toLowerCase() !== OPEN_CHAT_HASH) {
      return;
    }
    try {
      history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
      );
    } catch (e) { /* ignore */ }
    openChat();
  }

  consumeOpenChatHash();
  window.addEventListener("hashchange", consumeOpenChatHash);

}

// Lazy-loaded after first launcher click — DOMContentLoaded may already have fired
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCsChatbot);
} else {
  initCsChatbot();
}